// Reports Module
// PDF generation libraries loaded via script tags
// ============================================================================
// Reports List Filter Logic
// ============================================================================

// Helper: Get default date range (last month)
function getDefaultDateRange() {
    const now = new Date();
    const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    return {
        from: firstDayLastMonth,
        to: lastDayLastMonth
    };
}

// Helper: Parse date from input value (YYYY-MM-DD)
function parseDateInput(val) {
    if (!val) return null;
    const parts = val.split('-');
    if (parts.length !== 3) return null;
    return new Date(parts[0], parts[1] - 1, parts[2]);
}

// Main filter function
window.filterReports = async function() {
    const userData = getCurrentUser();
    const accountId = getEffectiveAccountId();
    
    if (!userData || !accountId) {
        // If SuperAdmin hasn't selected an account, show message
        if (userData && userData.role === 'SuperAdmin') {
            const tableBody = document.getElementById('reports-table-body');
            if (tableBody) {
                tableBody.innerHTML = `<tr><td colspan="7" class="px-4 py-12 text-center text-sm text-gray-500">Please select an account to view reports</td></tr>`;
            }
        }
        return;
    }

    // Get filter values
    const dateType = document.getElementById('report-date-filter')?.value || 'month';
    let fromDate, toDate;
    if (dateType === 'custom') {
        fromDate = parseDateInput(document.getElementById('report-date-from')?.value);
        toDate = parseDateInput(document.getElementById('report-date-to')?.value);
    } else if (dateType === 'month') {
        const range = getDefaultDateRange();
        fromDate = range.from;
        toDate = range.to;
    } else if (dateType === 'today') {
        const today = new Date();
        fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    } else if (dateType === 'week') {
        const now = new Date();
        const firstDay = new Date(now.setDate(now.getDate() - now.getDay()));
        const lastDay = new Date(now.setDate(now.getDate() - now.getDay() + 6));
        fromDate = firstDay;
        toDate = lastDay;
    } else {
        fromDate = null;
        toDate = null;
    }

    const templateId = document.getElementById('report-template-filter')?.value || 'all';
    const locationId = document.getElementById('report-location-filter')?.value || 'all';
    
    // Status filter: get checked values from checkboxes
    const statusCheckboxes = document.querySelectorAll('.status-checkbox:checked');
    let statuses = Array.from(statusCheckboxes).map(cb => cb.value);
    // Default to draft and published if nothing selected
    if (statuses.length === 0) {
        statuses = ['draft', 'published'];
    }

    // Build query params
    let params = `?account_id=${accountId}`;
    if (fromDate && toDate) {
        params += `&from_date=${fromDate.toISOString().slice(0,10)}&to_date=${toDate.toISOString().slice(0,10)}`;
    }
    if (templateId !== 'all') {
        params += `&template_id=${templateId}`;
    }
    if (locationId !== 'all') {
        params += `&location_id=${locationId}`;
    }
    if (statuses.length > 0) {
        params += `&statuses=${statuses.join(',')}`;
    }

    console.log('🔍 Fetching reports with params:', params);
    console.log('📅 Date filter:', dateType, 'From:', fromDate, 'To:', toDate);
    console.log('📋 Status filter:', statuses);

    // Fetch filtered reports
    const reports = await apiCall(`/reports/${params}`, {
        headers: auth.getAuthHeaders()
    });
    
    console.log('📊 Reports received:', reports?.length || 0, reports);

    // Table body
    const tableBody = document.getElementById('reports-table-body');
    if (!tableBody) return;
    if (!reports || reports.length === 0) {
        tableBody.innerHTML = `<tr><td colspan="7" class="px-4 py-12 text-center text-sm text-gray-500">No reports found</td></tr>`;
        document.getElementById('reports-total-count').textContent = '0 reports';
        return;
    }

    // Fetch users and locations for lookup
    const allUsers = await apiCall(`/users/?account_id=${accountId}&include_child_accounts=true`, {
        headers: auth.getAuthHeaders()
    });
    const usersMap = {};
    (allUsers.users || []).forEach(user => {
        usersMap[user._id] = user.full_name || user.name || user.username || 'Unknown User';
    });
    const allLocationsResp = await apiCall(`/locations?include_child_accounts=true`, {
        headers: auth.getAuthHeaders()
    });
    const locationsMap = {};
    (allLocationsResp.locations || []).forEach(loc => {
        locationsMap[loc.id] = loc.name;
    });

    // Find location input elementId from first report's template
    let locationElementId = null;
    if (reports.length > 0 && reports[0].template && Array.isArray(reports[0].template.elements)) {
        const locEl = reports[0].template.elements.find(el => el.elementType === 'location-input');
        if (locEl) locationElementId = locEl.id;
    }

    // Render filtered reports
    tableBody.innerHTML = reports.map(report => {
        // Format created date
        // Ensure UTC timestamp is properly parsed by adding 'Z' if missing
        let createdTimestamp = report.created_at;
        if (createdTimestamp && !createdTimestamp.endsWith('Z') && !createdTimestamp.includes('+')) {
            createdTimestamp += 'Z'; // Mark as UTC
        }
        const createdDate = new Date(createdTimestamp);
        const createdDateDisplay = createdDate.toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const createdTimeDisplay = createdDate.toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' });
        const createdDisplay = `<div>${createdDateDisplay}</div><div class="text-xs text-gray-400">${createdTimeDisplay}</div>`;
        
        // Format release date (if published)
        let releaseDisplay = '<span class="text-gray-400 text-xs">-</span>';
        if (report.status === 'published' && report.published_at) {
            let releaseTimestamp = report.published_at;
            if (releaseTimestamp && !releaseTimestamp.endsWith('Z') && !releaseTimestamp.includes('+')) {
                releaseTimestamp += 'Z'; // Mark as UTC
            }
            const releaseDate = new Date(releaseTimestamp);
            const releaseDateDisplay = releaseDate.toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: 'numeric' });
            const releaseTimeDisplay = releaseDate.toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' });
            releaseDisplay = `<div>${releaseDateDisplay}</div><div class="text-xs text-gray-400">${releaseTimeDisplay}</div>`;
        }
        
        const statusBadge = report.status === 'published' 
            ? `<span onclick="window.showStatusChangeMenu(event, '${report._id}', 'published')" class="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800 cursor-pointer hover:bg-green-200 transition-colors">Released</span>`
            : report.status === 'archived'
                ? `<span onclick="window.showStatusChangeMenu(event, '${report._id}', 'archived')" class="inline-flex items-center rounded-full bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-600 cursor-pointer hover:bg-gray-300 transition-colors">Archived</span>`
                : `<span onclick="window.showStatusChangeMenu(event, '${report._id}', 'draft')" class="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800 cursor-pointer hover:bg-yellow-200 transition-colors">Draft</span>`;

        const createdBy = usersMap[report.created_by] || 'Unknown User';
        let locationName = '';
        if (report.form_data?.location?.name) {
            locationName = report.form_data.location.name;
        } else if (locationElementId && report.form_data?.info?.[locationElementId]) {
            locationName = locationsMap[report.form_data.info[locationElementId]] || '';
        }
        if (!locationName) locationName = 'N/A';

        // Build row with all columns (visibility controlled by config)
        const columns = {
            created_date: `<td class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">${createdDisplay}</td>`,
            release_date: `<td class="py-4 px-3 text-sm text-gray-500">${releaseDisplay}</td>`,
            title: `<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">${escapeHtml(report.title)}</td>`,
            location: `<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">${escapeHtml(locationName)}</td>`,
            created_by: `<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">${escapeHtml(createdBy)}</td>`,
            template: `<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">${escapeHtml(report.template_name || 'N/A')}</td>`,
            status: `<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">${statusBadge}</td>`
        };
        
        // Get visible columns in order
        const visibleColumns = getReportsColumnsInOrder()
            .filter(col => col.visible)
            .map(col => columns[col.key])
            .join('');
        
        return `
            <tr>
                ${visibleColumns}
                <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <button onclick="viewReport('${report._id}')" class="text-primary-600 hover:text-primary-900 mr-4">View</button>
                    ${report.status === 'draft' ? `<button onclick="editReport('${report._id}')" class="text-primary-600 hover:text-primary-900 mr-4">Edit</button>` : ''}
                    ${report.status === 'draft' ? `<button onclick="deleteReport('${report._id}')" class="text-red-600 hover:text-red-900">Delete</button>` : ''}
                </td>
            </tr>
        `;
    }).join('');
    // Update count
    const countElement = document.getElementById('reports-total-count');
    if (countElement) {
        countElement.textContent = `${reports.length} report${reports.length === 1 ? '' : 's'}`;
    }
};

// Show status change menu next to clicked status badge
window.showStatusChangeMenu = function(event, reportId, currentStatus) {
    event.stopPropagation();
    
    // Remove any existing menu
    const existingMenu = document.getElementById('status-change-menu');
    if (existingMenu) {
        existingMenu.remove();
    }
    
    // Create menu
    const menu = document.createElement('div');
    menu.id = 'status-change-menu';
    menu.className = 'fixed bg-white rounded-lg shadow-xl border border-gray-200 py-1 z-50';
    menu.style.left = (event.pageX + 10) + 'px';
    menu.style.top = event.pageY + 'px';
    menu.style.minWidth = '150px';
    
    const statuses = [
        { value: 'draft', label: 'Draft', color: 'text-yellow-700', disabled: currentStatus === 'draft' },
        { value: 'published', label: 'Released', color: 'text-green-700', disabled: currentStatus === 'published' },
        { value: 'archived', label: 'Archived', color: 'text-gray-700', disabled: currentStatus === 'archived' }
    ];
    
    menu.innerHTML = statuses.map(status => `
        <button 
            onclick="window.changeReportStatus('${reportId}', '${status.value}')" 
            class="w-full text-left px-4 py-2 text-sm ${status.color} hover:bg-gray-100 ${status.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}"
            ${status.disabled ? 'disabled' : ''}>
            ${status.disabled ? '✓ ' : ''}${status.label}
        </button>
    `).join('');
    
    document.body.appendChild(menu);
    
    // Close menu when clicking outside
    const closeMenu = (e) => {
        if (!menu.contains(e.target)) {
            menu.remove();
            document.removeEventListener('click', closeMenu);
        }
    };
    
    setTimeout(() => {
        document.addEventListener('click', closeMenu);
    }, 100);
};

// Change report status
window.changeReportStatus = async function(reportId, newStatus) {
    try {
        // Close the menu
        const menu = document.getElementById('status-change-menu');
        if (menu) menu.remove();
        
        // Update report status via API
        await apiCall(`/reports/${reportId}`, {
            method: 'PATCH',
            headers: {
                ...auth.getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ status: newStatus })
        });
        
        // Refresh the reports list
        await window.filterReports();
        
        // Show success message
        const statusLabel = newStatus === 'published' ? 'Released' : newStatus === 'archived' ? 'Archived' : 'Draft';
        showSuccess(`Report status changed to ${statusLabel}`);
    } catch (error) {
        console.error('Failed to change report status:', error);
        showError('Failed to change report status: ' + (error.message || 'Unknown error'));
    }
};

// Toggle status filter dropdown
window.toggleStatusFilterDropdown = function() {
    const dropdown = document.getElementById('status-filter-dropdown');
    if (dropdown) {
        dropdown.classList.toggle('hidden');
    }
};

// Update status filter display text
window.updateStatusFilter = function() {
    const checkboxes = document.querySelectorAll('.status-checkbox:checked');
    const selected = Array.from(checkboxes);
    const display = document.getElementById('status-filter-display');
    
    if (display) {
        if (selected.length === 0) {
            display.textContent = 'Select status...';
            display.classList.add('text-gray-400');
        } else {
            const labels = selected.map(cb => {
                const label = cb.parentElement.textContent.trim();
                return label;
            });
            display.textContent = labels.join(', ');
            display.classList.remove('text-gray-400');
        }
    }
    
    // Trigger filter update
    window.filterReports();
};

// Close dropdown when clicking outside
setTimeout(() => {
    document.addEventListener('click', (e) => {
        const dropdown = document.getElementById('status-filter-dropdown');
        const button = document.getElementById('report-status-filter-btn');
        if (dropdown && button && !dropdown.contains(e.target) && !button.contains(e.target)) {
            dropdown.classList.add('hidden');
        }
    });
}, 0);

// Add custom date picker for "custom" range
setTimeout(() => {
    const dateFilter = document.getElementById('report-date-filter');
    if (!dateFilter) return;
    dateFilter.addEventListener('change', () => {
        if (dateFilter.value === 'custom') {
            // Insert custom date inputs if not present
            if (!document.getElementById('report-date-from')) {
                const parent = dateFilter.parentElement;
                const fromInput = document.createElement('input');
                fromInput.type = 'date';
                fromInput.id = 'report-date-from';
                fromInput.className = 'block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm px-3 py-2 mt-2';
                const toInput = document.createElement('input');
                toInput.type = 'date';
                toInput.id = 'report-date-to';
                toInput.className = 'block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm px-3 py-2 mt-2';
                parent.appendChild(fromInput);
                parent.appendChild(toInput);
                // Set default to last month
                const range = getDefaultDateRange();
                fromInput.value = range.from.toISOString().slice(0,10);
                toInput.value = range.to.toISOString().slice(0,10);
                fromInput.addEventListener('change', window.filterReports);
                toInput.addEventListener('change', window.filterReports);
            }
        } else {
            // Remove custom date inputs if present
            const fromInput = document.getElementById('report-date-from');
            const toInput = document.getElementById('report-date-to');
            if (fromInput) fromInput.remove();
            if (toInput) toInput.remove();
        }
    });
}, 0);
import { apiCall } from '../core/api.js';
import { auth } from '../core/auth.js';
import { showError, showSuccess } from '../core/ui.js';
import { t } from '../core/i18n.js';
import { updatePageTitle, updateActiveNavigation } from './navigation.js';
import { getCurrentUser, getEffectiveAccountId } from '../utils/helpers.js';
import { createCalendarPicker } from '../utils/calendar-picker.js';

// ============================================================================
// Utility Functions
// ============================================================================

/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

/**
 * Show confirmation dialog
 */
function showConfirmDialog(options) {
    return new Promise((resolve) => {
        const modal = document.createElement('div');
        modal.className = 'fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center';
        
        const iconColors = {
            warning: 'text-red-600',
            info: 'text-blue-600'
        };
        
        const iconColor = iconColors[options.icon] || 'text-gray-600';
        
        modal.innerHTML = `
            <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
                <div class="flex items-center mb-4">
                    <svg class="h-6 w-6 ${iconColor} mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    <h3 class="text-lg font-medium text-gray-900">${escapeHtml(options.title)}</h3>
                </div>
                <p class="text-sm text-gray-500 mb-6 whitespace-pre-line">${escapeHtml(options.message)}</p>
                <div class="flex justify-end gap-3">
                    <button id="cancel-btn" class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
                        ${escapeHtml(options.cancelText || 'Cancel')}
                    </button>
                    <button id="confirm-btn" class="px-4 py-2 rounded-md text-sm font-medium text-white ${options.confirmClass || 'bg-primary-600 hover:bg-primary-700'}">
                        ${escapeHtml(options.confirmText || 'Confirm')}
                    </button>
                </div>
            </div>
        `;
        
        document.body.appendChild(modal);
        
        const confirmBtn = modal.querySelector('#confirm-btn');
        const cancelBtn = modal.querySelector('#cancel-btn');
        
        confirmBtn.addEventListener('click', () => {
            document.body.removeChild(modal);
            resolve(true);
        });
        
        cancelBtn.addEventListener('click', () => {
            document.body.removeChild(modal);
            resolve(false);
        });
        
        // Close on background click
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                document.body.removeChild(modal);
                resolve(false);
            }
        });
    });
}

// ============================================================================
// Column Configuration
// ============================================================================

// Column visibility configuration for reports
const reportsColumnConfig = {
    created_date: { labelKey: 'Created', visible: true, sortable: true, default: true, order: 0 },
    release_date: { labelKey: 'Released', visible: true, sortable: true, default: true, order: 1 },
    title: { labelKey: 'Title', visible: true, sortable: true, default: true, order: 2 },
    location: { labelKey: 'Location', visible: true, sortable: true, default: true, order: 3 },
    created_by: { labelKey: 'Created By', visible: true, sortable: true, default: true, order: 4 },
    template: { labelKey: 'Template', visible: true, sortable: true, default: true, order: 5 },
    status: { labelKey: 'Status', visible: true, sortable: true, default: true, order: 6 }
};

function getReportsColumnsInOrder() {
    return Object.entries(reportsColumnConfig)
        .sort((a, b) => a[1].order - b[1].order)
        .map(([key, config]) => ({ key, ...config, label: config.labelKey }));
}

function loadReportsColumnPreferences() {
    const saved = localStorage.getItem('reportsColumnConfig');
    if (saved) {
        try {
            const preferences = JSON.parse(saved);
            Object.keys(preferences).forEach(key => {
                if (reportsColumnConfig[key]) {
                    if (preferences[key].visible !== undefined) {
                        reportsColumnConfig[key].visible = preferences[key].visible;
                    }
                    if (preferences[key].order !== undefined) {
                        reportsColumnConfig[key].order = preferences[key].order;
                    }
                }
            });
        } catch (e) {
            console.error('Error loading column preferences:', e);
        }
    }
}

function saveReportsColumnPreferences() {
    const preferences = {};
    Object.keys(reportsColumnConfig).forEach(key => {
        preferences[key] = {
            visible: reportsColumnConfig[key].visible,
            order: reportsColumnConfig[key].order
        };
    });
    localStorage.setItem('reportsColumnConfig', JSON.stringify(preferences));
}

function toggleReportColumn(columnKey) {
    if (reportsColumnConfig[columnKey]) {
        reportsColumnConfig[columnKey].visible = !reportsColumnConfig[columnKey].visible;
        saveReportsColumnPreferences();
        // Refresh the table display
        showReports();
        
        // Update the checkmark in the context menu if it's open
        const menu = document.getElementById('column-context-menu');
        if (menu) {
            const menuItem = menu.querySelector(`.column-menu-item[data-column-key="${columnKey}"]`);
            if (menuItem) {
                const svgs = menuItem.querySelectorAll('svg');
                if (svgs.length >= 2) {
                    const checkSvg = svgs[1];
                    if (reportsColumnConfig[columnKey].visible) {
                        checkSvg.classList.remove('text-transparent');
                        checkSvg.classList.add('text-primary-600');
                    } else {
                        checkSvg.classList.remove('text-primary-600');
                        checkSvg.classList.add('text-transparent');
                    }
                }
            }
        }
    }
}

function resetReportColumnsToDefault() {
    const defaultOrder = {
        created_date: 0, release_date: 1, title: 2, location: 3, created_by: 4, template: 5, status: 6
    };
    
    Object.keys(reportsColumnConfig).forEach(key => {
        reportsColumnConfig[key].visible = reportsColumnConfig[key].default;
        reportsColumnConfig[key].order = defaultOrder[key];
    });
    saveReportsColumnPreferences();
    showReports();
    
    const menu = document.getElementById('column-context-menu');
    if (menu) {
        menu.remove();
    }
}

function showReportColumnMenu(event) {
    event.preventDefault();
    
    const existingMenu = document.getElementById('column-context-menu');
    if (existingMenu) {
        existingMenu.remove();
    }
    
    const menu = document.createElement('div');
    menu.id = 'column-context-menu';
    menu.className = 'fixed bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50';
    menu.style.left = event.pageX + 'px';
    menu.style.top = event.pageY + 'px';
    menu.style.minWidth = '250px';
    
    const columnsInOrder = getReportsColumnsInOrder();
    
    const menuItems = columnsInOrder.map((column) => {
        const checkIcon = column.visible ? 
            '<svg class="w-4 h-4 text-primary-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>' :
            '<svg class="w-4 h-4 text-transparent" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>';
        
        return `
            <div 
                draggable="true"
                data-column-key="${column.key}"
                class="column-menu-item flex items-center px-4 py-2 hover:bg-gray-100 cursor-move select-none"
                onclick="event.stopPropagation(); window.toggleReportColumn('${column.key}')"
            >
                <svg class="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
                </svg>
                ${checkIcon}
                <span class="text-sm text-gray-700 ml-2">${column.label}</span>
            </div>
        `;
    }).join('');
    
    menu.innerHTML = `
        <div class="px-4 py-2 border-b border-gray-200">
            <p class="text-xs font-semibold text-gray-500 uppercase">Column Order & Visibility</p>
            <p class="text-xs text-gray-400 mt-1">Drag to reorder, click to toggle</p>
        </div>
        <div id="column-menu-items">
            ${menuItems}
        </div>
        <div class="border-t border-gray-200 mt-2">
            <button 
                onclick="window.resetReportColumnsToDefault()"
                class="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm text-primary-600"
            >
                Reset to Default
            </button>
        </div>
    `;
    
    document.body.appendChild(menu);
    
    setupReportColumnDragAndDrop();
    
    const closeMenu = (e) => {
        if (!menu.contains(e.target)) {
            menu.remove();
            document.removeEventListener('click', closeMenu);
        }
    };
    
    setTimeout(() => {
        document.addEventListener('click', closeMenu);
    }, 100);
}

function setupReportColumnDragAndDrop() {
    const items = document.querySelectorAll('.column-menu-item');
    let draggedItem = null;
    
    items.forEach(item => {
        item.addEventListener('dragstart', function(e) {
            draggedItem = this;
            this.style.opacity = '0.5';
            e.dataTransfer.effectAllowed = 'move';
        });
        
        item.addEventListener('dragend', function(e) {
            this.style.opacity = '1';
            
            const menuItems = document.querySelectorAll('.column-menu-item');
            menuItems.forEach((item, index) => {
                const key = item.getAttribute('data-column-key');
                reportsColumnConfig[key].order = index;
            });
            
            saveReportsColumnPreferences();
            showReports();
        });
        
        item.addEventListener('dragover', function(e) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            
            if (this === draggedItem) return;
            
            const container = this.parentNode;
            const allItems = [...container.querySelectorAll('.column-menu-item')];
            const draggedIndex = allItems.indexOf(draggedItem);
            const targetIndex = allItems.indexOf(this);
            
            if (draggedIndex < targetIndex) {
                this.parentNode.insertBefore(draggedItem, this.nextSibling);
            } else {
                this.parentNode.insertBefore(draggedItem, this);
            }
        });
    });
}

/**
 * Display the Reports page
 */
export async function showReports() {
    // Update navigation and page title
    updateActiveNavigation('reports');
    updatePageTitle('Reports');
    
    const mainContent = document.getElementById('main-content');
    if (!mainContent) return;

    if (!auth.isAuthenticated()) {
        showError('Please login to view reports');
        return;
    }

    mainContent.innerHTML = `
        <div class="px-4 sm:px-6 lg:px-8">
            <div class="bg-gray-200 shadow rounded-lg p-4">
                <div class="flex justify-end mb-3">
                    <button type="button" onclick="generateReport()" 
                            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 shadow-sm">
                        <svg class="mr-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                        Create Report
                    </button>
                </div>
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-3">
                    <div>
                        <label for="report-date-filter" class="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
                        <select id="report-date-filter" onchange="window.filterReports()" 
                                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm px-3 py-2">
                            <option value="all" selected>All dates</option>
                            <option value="month">Last month</option>
                            <option value="today">Today</option>
                            <option value="week">This week</option>
                            <option value="custom">Custom range</option>
                        </select>
                    </div>
                    <div>
                        <label for="report-template-filter" class="block text-sm font-medium text-gray-700 mb-1">Template</label>
                        <select id="report-template-filter" onchange="window.filterReports()" 
                                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm px-3 py-2">
                            <option value="all">All templates</option>
                        </select>
                    </div>
                    <div>
                        <label for="report-location-filter" class="block text-sm font-medium text-gray-700 mb-1">Location</label>
                        <select id="report-location-filter" onchange="window.filterReports()" 
                                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm px-3 py-2">
                            <option value="all">All locations</option>
                        </select>
                    </div>
                    <div class="relative">
                        <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
                        <button type="button" id="report-status-filter-btn" onclick="window.toggleStatusFilterDropdown()"
                                class="relative w-full cursor-pointer rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 sm:text-sm">
                            <span id="status-filter-display" class="block truncate">Draft, Released</span>
                            <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z" clip-rule="evenodd" />
                                </svg>
                            </span>
                        </button>
                        <div id="status-filter-dropdown" class="hidden absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg">
                            <div class="py-1" role="menu">
                                <label class="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                    <input type="checkbox" value="draft" checked onchange="window.updateStatusFilter()" class="status-checkbox h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500">
                                    <span class="ml-2 text-sm text-gray-700">Draft</span>
                                </label>
                                <label class="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                    <input type="checkbox" value="published" checked onchange="window.updateStatusFilter()" class="status-checkbox h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500">
                                    <span class="ml-2 text-sm text-gray-700">Released</span>
                                </label>
                                <label class="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                    <input type="checkbox" value="archived" onchange="window.updateStatusFilter()" class="status-checkbox h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500">
                                    <span class="ml-2 text-sm text-gray-700">Archived</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end">
                    <button type="button" onclick="window.clearReportFilters()" 
                            class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                        Clear filters
                    </button>
                </div>
            </div>
            <div id="reports-count-info" class="mb-4 px-1 mt-6">
                <div class="flex items-center justify-between">
                    <div class="text-sm text-gray-600">
                        <span id="reports-total-count">0 reports</span>
                    </div>
                    <div class="text-xs text-gray-400 italic">
                        💡 Right-click table header to customize columns
                    </div>
                </div>
            </div>
            <div class="mt-6 flow-root">
                <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-300">
                                <thead class="bg-gray-200" oncontextmenu="window.showReportColumnMenu(event); return false;">
                                    <tr>
                                        ${getReportsColumnsInOrder().filter(col => col.visible).map(col => `
                                            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ${col.key === 'date' ? 'pl-4 pr-3 sm:pl-6' : ''}">
                                                ${col.label}
                                            </th>
                                        `).join('')}
                                        <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span class="sr-only">Actions</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody id="reports-table-body" class="divide-y divide-gray-200 bg-white">
                                    <tr>
                                        <td colspan="7" class="px-4 py-12 text-center text-sm text-gray-500">
                                            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-semibold text-gray-900">No reports found</h3>
                                            <p class="mt-1 text-sm text-gray-500">Get started by generating your first report.</p>
                                            <div class="mt-6">
                                                <button type="button" onclick="generateReport()" 
                                                        class="inline-flex items-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500">
                                                    <svg class="-ml-0.5 mr-1.5 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path d="M12 4.5v15m7.5-7.5h-15" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                    </svg>
                                                    Create Report
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

    // Populate template and location filters dynamically
    setTimeout(async () => {
        const userData = getCurrentUser();
        const accountId = getEffectiveAccountId();
        if (!accountId) return;
        
        // Templates
        try {
            const response = await apiCall(`/report-templates/templates?account_id=${accountId}&is_released=true`, {
                headers: auth.getAuthHeaders()
            });
            const templates = response.templates || response || [];
            const templateSelect = document.getElementById('report-template-filter');
            if (templateSelect) {
                templateSelect.innerHTML = '<option value="all">All templates</option>' +
                    templates.map(t => `<option value="${t._id}">${escapeHtml(t.name)}</option>`).join('');
            }
        } catch (e) { /* ignore */ }
        // Locations
        try {
            const locResp = await apiCall(`/locations?include_child_accounts=true`, {
                headers: auth.getAuthHeaders()
            });
            const locations = locResp.locations || [];
            const locationSelect = document.getElementById('report-location-filter');
            if (locationSelect) {
                locationSelect.innerHTML = '<option value="all">All locations</option>' +
                    locations.map(l => `<option value="${l.id}">${escapeHtml(l.name)}</option>`).join('');
            }
        } catch (e) { /* ignore */ }
    }, 0);

    // Load reports from API (filtered)
    await window.filterReports();
}

// ============================================================================
// Report Creation State
// ============================================================================

const reportCreationState = {
    templates: [],
    selectedTemplate: null,
    currentReport: null,
    currentTab: 'info', // 'info' or 'documentation'
    formData: {
        info: {},
        documentation: []
    }
};

/**
 * Generate a new report - Step 1: Select template
 */
export async function generateReport() {
    try {
        // Load released templates
        const userData = getCurrentUser();
        const accountId = getEffectiveAccountId();
        
        if (!userData || !accountId) {
            showError(userData && userData.role === 'SuperAdmin' ? 'Please select an account first' : 'User account not found');
            return;
        }

        const response = await apiCall(`/report-templates/templates?account_id=${accountId}&is_released=true`, {
            headers: auth.getAuthHeaders()
        });

        // Filter to only show released templates (extra safety in case backend doesn't filter)
        const allTemplates = response.templates || response || [];
        reportCreationState.templates = allTemplates.filter(template => template.is_released === true);

        if (reportCreationState.templates.length === 0) {
            showError('No released templates available. Please release a template first.');
            return;
        }

        // Show template selection modal
        showTemplateSelectionModal();
    } catch (error) {
        console.error('Failed to load templates:', error);
        showError('Failed to load templates: ' + (error.message || 'Unknown error'));
    }
}

/**
 * Show template selection modal
 */
function showTemplateSelectionModal() {
    const modal = document.createElement('div');
    modal.id = 'template-selection-modal';
    modal.className = 'fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center';
    
    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    
    modal.innerHTML = `
        <div class="relative bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4">
            <div class="px-6 py-4 border-b border-gray-200">
                <h3 class="text-lg font-medium text-gray-900">Select Template</h3>
                <p class="mt-1 text-sm text-gray-500">Choose a template to create your report</p>
            </div>
            
            <div class="px-6 py-4 max-h-96 overflow-y-auto">
                <div class="space-y-3" id="template-selection-list">
                    ${reportCreationState.templates.map(template => `
                        <div class="border rounded-lg p-4 hover:bg-primary-50 cursor-pointer transition-colors" 
                             onclick="window.selectTemplateForReport('${template._id}')">
                            <h4 class="font-medium text-gray-900">${escapeHtml(template.name)}</h4>
                            ${template.description ? `<p class="text-sm text-gray-500 mt-1">${escapeHtml(template.description)}</p>` : ''}
                            <div class="mt-2 flex items-center text-xs text-gray-400">
                                <svg class="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Released
                            </div>
                        </div>
                    `).join('')}
                </div>
            </div>
            
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end">
                <button onclick="window.closeTemplateSelectionModal()" 
                        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                    Cancel
                </button>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    // Close on background click
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            closeTemplateSelectionModal();
        }
    });
}

/**
 * Close template selection modal
 */
function closeTemplateSelectionModal() {
    const modal = document.getElementById('template-selection-modal');
    if (modal) {
        modal.remove();
    }
}

/**
 * Select template and open edit dialog - Step 2
 */
async function selectTemplateForReport(templateId) {
    try {
        reportCreationState.selectedTemplate = templateId;
        
        // Load template metadata
        const template = await apiCall(`/report-templates/templates/${templateId}`, {
            headers: auth.getAuthHeaders()
        });
        
        // Load template elements (separate endpoint in backend)
        const elements = await apiCall(`/report-templates/templates/${templateId}/elements`, {
            headers: auth.getAuthHeaders()
        });
        
        // Transform backend snake_case to frontend camelCase
        const transformedElements = elements.map(el => {
            // Debug log RAW element data for documentation elements
            if (el.element_type === 'evaluation-input' || el.element_type === 'image-text-input') {
                console.log('📦 RAW element from API:', el);
                console.log('   RAW config:', el.config);
                console.log('   Config type:', typeof el.config);
                console.log('   Config keys:', el.config ? Object.keys(el.config) : 'null');
            }
            
            const transformed = {
                ...el,
                elementType: el.element_type,
                introText: el.intro_text,
                staticData: el.static_data,
                inputRequired: el.input_required,
                inputOptions: el.input_options,
                order: el.position,  // Backend uses 'position', frontend uses 'order'
                config: el.config || {}  // Ensure config is included
            };
            
            // Debug log for documentation elements
            if (transformed.elementType === 'evaluation-input' || transformed.elementType === 'image-text-input') {
                console.log('📋 Transformed documentation element:', transformed);
                console.log('   Transformed config:', transformed.config);
                console.log('   Structure in config:', transformed.config.structure);
            }
            
            return transformed;
        });
        
        // Combine template and elements
        template.elements = transformedElements;

        // Check if elements exist
        if (!template.elements || template.elements.length === 0) {
            closeTemplateSelectionModal();
            showError('This template has no elements defined. Please edit the template to add elements before creating a report.');
            return;
        }

        closeTemplateSelectionModal();
        
        // Initialize new report
        reportCreationState.currentReport = {
            template_id: templateId,
            template_name: template.name,
            template: template,
            status: 'draft',
            title: '',
            info_data: {},
            documentation_data: []
        };

        // Reset form data
        reportCreationState.formData = {
            info: {},
            documentation: []
        };

        reportCreationState.currentTab = 'info';

        // Show edit dialog
        showReportEditDialog();
    } catch (error) {
        console.error('Failed to load template:', error);
        showError('Failed to load template: ' + (error.message || 'Unknown error'));
    }
}

// ============================================================================
// Reusable documentation collection (shared with the Tasks "Resolve" flow)
// ============================================================================

/**
 * Load a report template (metadata + elements) and transform element fields
 * from backend snake_case to the camelCase shape the renderers expect.
 * Shared by Create Report and the Tasks "Resolve" documentation tab.
 */
export async function loadReportTemplateWithElements(templateId) {
    const template = await apiCall(`/report-templates/templates/${templateId}`, {
        headers: auth.getAuthHeaders()
    });
    const elements = await apiCall(`/report-templates/templates/${templateId}/elements`, {
        headers: auth.getAuthHeaders()
    });
    template.elements = (elements || []).map(el => ({
        ...el,
        elementType: el.element_type,
        introText: el.intro_text,
        staticData: el.static_data,
        inputRequired: el.input_required,
        inputOptions: el.input_options,
        order: el.position,
        config: el.config || {}
    }));
    return template;
}

/**
 * Initialize the shared documentation state for a task resolution, seeding it
 * with the task's linked template and any previously captured entries.
 */
export function initTaskResolutionDocumentation(template, existingDocumentation = []) {
    reportCreationState.currentReport = {
        template_id: template._id || template.id,
        template_name: template.name,
        template,
        status: 'draft',
        title: template.name || ''
    };
    reportCreationState.currentTab = 'documentation';
    reportCreationState.formData = {
        info: {},
        documentation: Array.isArray(existingDocumentation)
            ? existingDocumentation.filter(Boolean).map(d => ({ ...d }))
            : []
    };
}

/**
 * Render the documentation collection UI (same as Create Report) into a host
 * container owned by the Tasks resolve modal. The container is given the id
 * the report machinery re-renders into after each entry is saved.
 */
export function renderTaskResolutionDocumentation(container) {
    if (!container) return;
    container.id = 'tab-content-area';
    reportCreationState.currentTab = 'documentation';
    renderDocumentationTab(container);
}

/**
 * Read back the documentation entries collected for a task resolution.
 */
export function getTaskResolutionDocumentation() {
    if (!reportCreationState.formData) return [];
    const template = reportCreationState.currentReport?.template;
    if (template && template.documentation_layout === 'dynamic') {
        const dyn = reportCreationState.formData.dynamicDocumentation || {};
        const flattened = [];
        Object.keys(dyn).forEach(zone => {
            (dyn[zone] || []).forEach(entry => flattened.push({ ...entry, zone }));
        });
        return flattened;
    }
    return reportCreationState.formData.documentation || [];
}

/**
 * Create a published Report from the documentation collected while resolving a
 * task. Returns the created report (so the caller can link it via report_id).
 */
export async function createReportFromTaskResolution({ template, title, accountId, location }) {
    const formData = { ...reportCreationState.formData };
    if (location) formData.location = location;

    const reportData = {
        title: title || template.name || 'Task documentation',
        template_id: template._id || template.id,
        template_name: template.name,
        template,
        account_id: accountId,
        status: 'published',
        form_data: formData,
        documentation: getTaskResolutionDocumentation()
    };

    return apiCall('/reports/', {
        method: 'POST',
        headers: auth.getAuthHeaders(),
        body: JSON.stringify(reportData)
    });
}

/**
 * Show report edit dialog with Info and Documentation tabs - Step 3
 */
function showReportEditDialog() {
    const modal = document.createElement('div');
    modal.id = 'report-edit-modal';
    modal.className = 'fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50';
    
    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    
    modal.innerHTML = `
        <div class="min-h-screen px-4 py-8">
            <div class="relative bg-white rounded-lg shadow-xl max-w-4xl mx-auto">
                <!-- Header -->
                <div class="px-6 py-4 border-b border-gray-200">
                    <div class="flex items-center justify-between">
                        <div>
                            <h3 class="text-lg font-medium text-gray-900">Create Report</h3>
                            <p class="mt-1 text-sm text-gray-500">Template: ${escapeHtml(reportCreationState.currentReport.template_name)}</p>
                        </div>
                        <button onclick="window.closeReportEditDialog()" class="text-gray-400 hover:text-gray-500">
                            <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Tabs -->
                <div class="border-b border-gray-200">
                    <nav class="-mb-px flex px-6" aria-label="Tabs">
                        <button onclick="window.switchReportTab('info')" 
                                class="report-tab whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm ${
                                    reportCreationState.currentTab === 'info' 
                                    ? 'border-primary-500 text-primary-600' 
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }" 
                                data-tab="info">
                            Info
                        </button>
                        <button onclick="window.switchReportTab('documentation')" 
                                class="report-tab ml-8 whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm ${
                                    reportCreationState.currentTab === 'documentation' 
                                    ? 'border-primary-500 text-primary-600' 
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }" 
                                data-tab="documentation">
                            Documentation
                        </button>
                    </nav>
                </div>

                <!-- Tab Content -->
                <div class="px-6 py-6">
                    <div id="tab-content-area" class="max-h-96 overflow-y-auto">
                        <!-- Content will be rendered here -->
                    </div>
                </div>

                <!-- Footer -->
                <div class="px-6 py-4 border-t border-gray-200 flex justify-between">
                    <button onclick="window.closeReportEditDialog()" 
                            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                        Cancel
                    </button>
                    <div class="flex space-x-3">
                        <button onclick="window.saveReportDraft()" 
                                class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                            Save Draft
                        </button>
                        <button onclick="window.publishReport()" 
                                class="px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700">
                            Release Report
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    // Render initial tab content (Info tab)
    renderTabContent();
}

/**
 * Close report edit dialog
 */
function closeReportEditDialog() {
    const modal = document.getElementById('report-edit-modal');
    if (modal) {
        modal.remove();
    }
    reportCreationState.currentReport = null;
    reportCreationState.selectedTemplate = null;
    reportCreationState.currentTab = 'info';
}

/**
 * Switch between Info and Documentation tabs
 */
function switchReportTab(tab) {
    reportCreationState.currentTab = tab;

    // Update tab styles
    document.querySelectorAll('.report-tab').forEach(tabBtn => {
        const tabName = tabBtn.dataset.tab;
        if (tabName === tab) {
            tabBtn.className = 'report-tab whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm border-primary-500 text-primary-600';
        } else {
            tabBtn.className = 'report-tab whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300';
        }
    });

    // Render tab content
    renderTabContent();
}

/**
 * Render content for current tab
 */
function renderTabContent() {
    const contentArea = document.getElementById('tab-content-area');
    if (!contentArea) return;

    if (reportCreationState.currentTab === 'info') {
        renderInfoTab(contentArea);
    } else if (reportCreationState.currentTab === 'documentation') {
        renderDocumentationTab(contentArea);
    }
}

/**
 * Render Info tab with input elements
 */
function renderInfoTab(container) {
    const template = reportCreationState.currentReport.template;
    const elements = template.elements || [];

    // Debug logging
    console.log('Template elements:', elements);
    console.log('Total elements:', elements.length);
    elements.forEach(el => {
        console.log('Element:', el.elementType, 'Order:', el.order, 'Page:', el.page);
    });

    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };

    // Filter input elements (exclude documentation elements) and sort by order
    const inputElements = elements.filter(el => {
        const infoElementTypes = [
            'text-input',
            'date-input',
            'location-input',
            'user-input',
            'tag-input',
            'image-input',
            'statistics-input',
            'creator-name',
            'location-contacts'
        ];
        return infoElementTypes.includes(el.elementType);
    }).sort((a, b) => (a.order || 0) - (b.order || 0));

    console.log('Filtered input elements:', inputElements.length);
    console.log('Input elements:', inputElements);

    if (inputElements.length === 0) {
        container.innerHTML = `
            <div class="text-center py-12 text-gray-500">
                <p>No input fields in this template</p>
            </div>
        `;
        return;
    }

    // Render all input elements
    container.innerHTML = `
        <div class="space-y-6">
            <!-- Report Title -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Report Title <span class="text-red-500">*</span>
                </label>
                <input type="text" 
                       id="report-title" 
                       value="${escapeHtml(reportCreationState.currentReport.title || '')}"
                       oninput="window.updateReportTitle(this.value)"
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500" 
                       placeholder="Enter report title">
            </div>

            <!-- Input Elements -->
            ${inputElements.map((element, index) => renderInputElement(element, index)).join('')}
        </div>
    `;
}

/**
 * Render a single input element
 */
function renderInputElement(element, index) {
    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    
    const label = element.introText || element.config?.label || 'Input';
    const required = element.inputRequired ? '<span class="text-red-500">*</span>' : '';
    const dataKey = `element-${index}`;  // Use sequential index as key
    const elementId = element.id || dataKey;  // Keep element ID for DOM IDs

    switch (element.elementType) {
        case 'text-input':
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)} ${required}
                    </label>
                    <textarea 
                        id="input-${elementId}" 
                        rows="3"
                        oninput="window.updateFormData('info', '${dataKey}', this.value)"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500" 
                        placeholder="Enter text">${reportCreationState.formData.info[dataKey] || ''}</textarea>
                </div>
            `;

        case 'date-input':
            // Get current value or default to now
            const currentDatetimeValue = reportCreationState.formData.info[dataKey];
            let defaultDatetimeValue;
            
            if (currentDatetimeValue) {
                // Use existing value
                defaultDatetimeValue = currentDatetimeValue;
            } else {
                // Auto-save current datetime if no value exists
                const now = new Date();
                // Format as YYYY-MM-DDTHH:MM (datetime-local format)
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                defaultDatetimeValue = `${year}-${month}-${day}T${hours}:${minutes}`;
                window.updateFormData('info', dataKey, defaultDatetimeValue);
            }
            
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)} ${required}
                    </label>
                    <input 
                        type="datetime-local" 
                        id="input-${elementId}"
                        value="${defaultDatetimeValue}"
                        onchange="window.updateFormData('info', '${dataKey}', this.value)"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500" />
                </div>
            `;

        case 'location-input':
            // Trigger loading locations when rendering
            setTimeout(() => loadLocationsForSelect(elementId, dataKey), 0);
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)} ${required}
                    </label>
                    <select 
                        id="input-${elementId}" 
                        ${element.config?.allowMultiple ? 'multiple' : ''}
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500">
                        <option value="">Loading locations...</option>
                    </select>
                </div>
            `;

        case 'user-input':
            // Trigger loading users when rendering
            setTimeout(() => loadUsersForSelect(elementId, dataKey), 0);
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)} ${required}
                    </label>
                    <select 
                        id="input-${elementId}" 
                        ${element.config?.allowMultiple ? 'multiple' : ''}
                        onchange="window.updateFormData('info', '${dataKey}', this.value)"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500">
                        <option value="">Loading users...</option>
                    </select>
                </div>
            `;

        case 'tag-input':
            // Trigger loading tags when rendering
            setTimeout(() => loadTagsForSelect(elementId, dataKey, element.config), 0);
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)} ${required}
                    </label>
                    <div id="input-${elementId}" class="space-y-2">
                        <p class="text-sm text-gray-500">Loading tags...</p>
                    </div>
                </div>
            `;

        case 'creator-name':
            const currentUserData = getCurrentUser();
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)}
                    </label>
                    <input 
                        type="text" 
                        value="${escapeHtml(currentUserData?.full_name || currentUserData?.name || currentUserData?.username || '')}"
                        disabled
                        class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500">
                </div>
            `;

        case 'location-contacts':
            return `
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        ${escapeHtml(label)}
                    </label>
                    <div id="location-contacts-${elementId}" class="text-sm text-gray-500">
                        <p class="italic">Select a location to view external users</p>
                    </div>
                </div>
            `;

        default:
            return '';
    }
}

/**
 * Render Documentation tab
 */
function renderDocumentationTab(container) {
    const template = reportCreationState.currentReport.template;
    const elements = template.elements || [];
    const documentationLayout = template.documentation_layout || 'structured';

    console.log('=== Documentation Tab Rendering ===');
    console.log('Total elements:', elements.length);
    console.log('Documentation layout:', documentationLayout);
    console.log('All elements:', elements);

    // Handle dynamic templates differently
    if (documentationLayout === 'dynamic') {
        renderDocumentationDynamic(container, elements);
        return;
    }

    // Structured template logic (original)
    // Find documentation element (evaluation-input or image-text-input) on data page
    const docElement = elements.find(el => 
        el.page === 'data' &&
        (el.elementType === 'evaluation-input' || el.elementType === 'image-text-input')
    );

    console.log('Documentation element found:', docElement);
    console.log('Element ID:', docElement?.id);
    console.log('Element _ID:', docElement?._id);

    if (!docElement) {
        console.log('No documentation element found in template');
        container.innerHTML = `
            <div class="text-center py-12 text-gray-500">
                <p>No documentation elements in this template</p>
            </div>
        `;
        return;
    }

    // Check if structure is defined
    const structure = docElement.config?.structure || [];
    const hasStructure = structure.length > 0;

    console.log('Structure:', structure);
    console.log('Has structure:', hasStructure);
    console.log('Structure length:', structure.length);

    if (hasStructure) {
        console.log('Rendering with structure tree');
        // Render structure tree for navigation
        renderDocumentationWithStructure(container, docElement, structure);
    } else {
        console.log('Rendering simple documentation list');
        // Render simple list with first element and + button
        renderDocumentationSimple(container, docElement);
    }
}

/**
 * Build expandable tree structure HTML (recursive)
 */
function buildStructureTreeHTML(nodes, docElement, parentPath = '', depth = 0, allEndpoints = []) {
    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    
    const elementId = docElement.id || docElement._id;
    let html = '';
    
    nodes.forEach((node) => {
        const nodeName = node.name || '';
        const currentPath = parentPath ? `${parentPath} > ${nodeName}` : nodeName;
        const hasChildren = node.children && node.children.length > 0;
        const marginLeft = depth * 16;
        
        if (hasChildren) {
            // Parent node - expandable
            html += `
                <div class="structure-node" style="margin-left: ${marginLeft}px; margin-bottom: 4px;">
                    <div class="structure-node-header flex items-center px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
                         onclick="toggleStructureNode(this)">
                        <svg class="structure-chevron w-5 h-5 text-gray-600 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                        </svg>
                        <span class="ml-2 text-sm font-semibold text-gray-800">${escapeHtml(nodeName)}</span>
                    </div>
                    <div class="structure-node-children" style="display: none;">
                        ${buildStructureTreeHTML(node.children, docElement, currentPath, depth + 1, allEndpoints)}
                    </div>
                </div>
            `;
        } else {
            // Leaf node - clickable endpoint
            const endpointIndex = allEndpoints.indexOf(currentPath);
            const isCompleted = endpointIndex >= 0 && 
                               reportCreationState.formData.documentation[endpointIndex];
            
            html += `
                <div class="structure-endpoint flex items-center justify-between px-3 py-2 border rounded-lg cursor-pointer transition-colors ${
                    isCompleted ? 'bg-green-50 border-green-100 hover:bg-green-100' : 'bg-white border-gray-200 hover:bg-gray-50'
                }"
                     style="margin-left: ${marginLeft}px; margin-bottom: 4px;"
                     onclick="window.openDocumentationEntry('${elementId}', ${endpointIndex}, '${currentPath.replace(/'/g, "\\'")}')">
                    <div class="flex items-center">
                        <svg class="w-4 h-4 ${isCompleted ? 'text-green-600' : 'text-gray-400'}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                        </svg>
                        <span class="ml-2 text-sm text-gray-700">${escapeHtml(nodeName)}</span>
                    </div>
                    ${isCompleted 
                        ? '<svg class="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>'
                        : '<span class="text-xs text-gray-400">Not started</span>'
                    }
                </div>
            `;
        }
    });
    
    return html;
}

/**
 * Toggle structure node expansion
 */
window.toggleStructureNode = function(headerElement) {
    const nodeElement = headerElement.parentElement;
    const childrenContainer = nodeElement.querySelector('.structure-node-children');
    const chevron = headerElement.querySelector('.structure-chevron');
    
    if (childrenContainer.style.display === 'none') {
        childrenContainer.style.display = 'block';
        chevron.style.transform = 'rotate(90deg)';
    } else {
        childrenContainer.style.display = 'none';
        chevron.style.transform = 'rotate(0deg)';
    }
};

/**
 * Render documentation with structure tree
 */
function renderDocumentationWithStructure(container, docElement, structure) {
    // Get all endpoint paths
    const endpoints = getAllStructureEndpoints(structure);

    container.innerHTML = `
        <div class="space-y-4">
            <!-- Structure Tree -->
            <div class="border rounded-lg p-4">
                <h4 class="font-medium text-gray-900 mb-3">Select area to document:</h4>
                <div id="structure-tree">
                    ${buildStructureTreeHTML(structure, docElement, '', 0, endpoints)}
                </div>
            </div>

            <!-- Summary -->
            <div class="text-sm text-gray-500">
                ${reportCreationState.formData.documentation.filter(d => d).length} of ${endpoints.length} areas documented
            </div>
        </div>
    `;
}

/**
 * Render documentation without structure (simple list)
 */
function renderDocumentationSimple(container, docElement) {
    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    
    const docs = reportCreationState.formData.documentation || [];

    container.innerHTML = `
        <div class="space-y-4">
            <div class="bg-blue-50 border border-blue-200 rounded-md p-4">
                <p class="text-sm text-blue-800">
                    Add documentation entries. Each entry can include ${
                        docElement.elementType === 'evaluation-input' ? 'evaluation score, text, and images' : 'images and text'
                    }.
                </p>
            </div>

            <!-- Documentation entries -->
            <div class="space-y-3">
                ${docs.length === 0 ? `
                    <div class="text-center py-8 text-gray-500">
                        <p>No documentation entries yet</p>
                        <p class="text-sm mt-1">Click the button below to add your first entry</p>
                    </div>
                ` : docs.map((doc, index) => `
                    <div class="border rounded-lg p-4 hover:bg-gray-50">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h4 class="font-medium text-gray-900">Entry ${index + 1}</h4>
                                ${doc.evaluation ? `<p class="text-sm text-gray-500">Score: ${doc.evaluation}</p>` : ''}
                                ${doc.text ? `<p class="text-sm text-gray-600 mt-1">${escapeHtml(doc.text.substring(0, 100))}${doc.text.length > 100 ? '...' : ''}</p>` : ''}
                            </div>
                            <div class="flex items-center space-x-2">
                                <button onclick="window.editDocumentationEntry('${docElement.id}', ${index})" 
                                        class="text-primary-600 hover:text-primary-700">
                                    Edit
                                </button>
                                <button onclick="window.deleteDocumentationEntry(${index})" 
                                        class="text-red-600 hover:text-red-700">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                `).join('')}
            </div>

            <!-- Add button -->
            <button onclick="window.openDocumentationEntry('${docElement.id}', -1, null)" 
                    class="w-full py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-primary-500 hover:text-primary-600 transition-colors">
                <svg class="inline-block h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Add Documentation Entry
            </button>
        </div>
    `;
}

/**
 * Render documentation for dynamic templates
 */
function renderDocumentationDynamic(container, elements) {
    const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    
    // Group elements by zone (dynamic-0, dynamic-1, etc.)
    const elementsByZone = {};
    elements.forEach(el => {
        if (el.page === 'data' && el.zone && el.zone.startsWith('dynamic-')) {
            if (!elementsByZone[el.zone]) {
                elementsByZone[el.zone] = [];
            }
            elementsByZone[el.zone].push(el);
        }
    });
    
    // Sort zones by index
    const sortedZones = Object.keys(elementsByZone).sort((a, b) => {
        const indexA = parseInt(a.replace('dynamic-', ''));
        const indexB = parseInt(b.replace('dynamic-', ''));
        return indexA - indexB;
    });
    
    if (sortedZones.length === 0) {
        container.innerHTML = `
            <div class="text-center py-12 text-gray-500">
                <p>No documentation elements in this template</p>
            </div>
        `;
        return;
    }
    
    // Initialize documentation data structure if not exists
    if (!reportCreationState.formData.dynamicDocumentation) {
        reportCreationState.formData.dynamicDocumentation = {};
    }
    
    let html = '<div class="space-y-6">';
    
    html += `
        <div class="bg-blue-50 border border-blue-200 rounded-md p-4">
            <p class="text-sm text-blue-800">
                This template uses dynamic documentation. Add entries for each category below.
            </p>
        </div>
    `;
    
    sortedZones.forEach((zoneName, zoneIndex) => {
        const zoneElements = elementsByZone[zoneName];
        const docElement = zoneElements[0]; // Primary element in this zone
        
        const multiEntry = docElement.multiEntry || docElement.multi_entry || false;
        const elementIdForCallback = docElement.id || docElement._id;
        
        // Get entries for this zone
        if (!reportCreationState.formData.dynamicDocumentation[zoneName]) {
            reportCreationState.formData.dynamicDocumentation[zoneName] = [];
        }
        const entries = reportCreationState.formData.dynamicDocumentation[zoneName];
        
        html += `
            <div class="border-2 border-gray-300 rounded-lg p-4 bg-white">
                <div class="flex items-center justify-between mb-3">
                    <h4 class="text-base font-semibold text-gray-900">
                        ${docElement.elementType === 'evaluation-input' ? 'Evaluation, Image and Text' : 'Image and Text'}
                        ${multiEntry ? '<span class="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">Multiple entries allowed</span>' : ''}
                    </h4>
                </div>
                
                <!-- Entries for this zone -->
                <div class="space-y-3 mb-3">
                    ${entries.length === 0 && !multiEntry ? `
                        <!-- For non-multi-entry, show the form directly -->
                        <div class="border-2 border-blue-200 rounded-lg p-4 bg-blue-50">
                            <p class="text-sm text-blue-800 mb-3">Click below to add your entry for this section</p>
                            <button onclick="addDynamicEntry('${zoneName}', '${elementIdForCallback}')" 
                                    class="w-full py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-medium transition-colors">
                                <svg class="inline-block h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                                </svg>
                                Add Entry
                            </button>
                        </div>
                    ` : entries.length === 0 ? `
                        <!-- For multi-entry with no entries yet -->
                        <div class="text-center py-6 text-gray-400 border-2 border-dashed border-gray-200 rounded-lg">
                            <p class="text-sm">No entries yet</p>
                            <p class="text-xs mt-1">Click the button below to add your first entry</p>
                        </div>
                    ` : entries.map((entry, entryIndex) => `
                        <div class="border rounded-lg p-3 hover:bg-gray-50">
                            <div class="flex items-center justify-between">
                                <div class="flex-1">
                                    <h5 class="font-medium text-gray-900 text-sm">Entry ${entryIndex + 1}</h5>
                                    ${entry.evaluation !== undefined ? `<p class="text-sm text-gray-500">Score: ${entry.evaluation}</p>` : ''}
                                    ${entry.text ? `<p class="text-sm text-gray-600 mt-1">${escapeHtml(entry.text.substring(0, 80))}${entry.text.length > 80 ? '...' : ''}</p>` : ''}
                                    ${entry.images && entry.images.length > 0 ? `<p class="text-xs text-gray-400 mt-1">${entry.images.length} image(s)</p>` : ''}
                                </div>
                                <div class="flex items-center space-x-2">
                                    <button onclick="editDynamicEntry('${zoneName}', ${entryIndex}, '${elementIdForCallback}')" 
                                            class="text-primary-600 hover:text-primary-700 text-sm">
                                        Edit
                                    </button>
                                    <button onclick="deleteDynamicEntry('${zoneName}', ${entryIndex})" 
                                            class="text-red-600 hover:text-red-700 text-sm">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    `).join('')}
                </div>
                
                <!-- Add button (only for multi-entry) -->
                ${multiEntry ? `
                    <button onclick="addDynamicEntry('${zoneName}', '${elementIdForCallback}')" 
                            class="w-full py-2.5 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-600 hover:border-primary-500 hover:text-primary-600 transition-colors">
                        <svg class="inline-block h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Add ${entries.length > 0 ? 'Another' : ''} Entry
                    </button>
                ` : ''}
            </div>
        `;
    });
    
    html += '</div>';
    container.innerHTML = html;
}

/**
 * Helper function to get all structure endpoint paths
 */
function getAllStructureEndpoints(nodes, parentPath = []) {
    let endpoints = [];
    
    nodes.forEach(node => {
        const currentPath = [...parentPath, node.name];
        
        if (!node.children || node.children.length === 0) {
            endpoints.push(currentPath.join(' > '));
        } else {
            endpoints = endpoints.concat(getAllStructureEndpoints(node.children, currentPath));
        }
    });
    
    return endpoints;
}

/**
 * Load locations for select dropdown
 */
async function loadLocationsForSelect(elementId, dataKey) {
    try {
        const userData = getCurrentUser();
        if (!userData || !userData.account_id) return;

        const response = await apiCall(`/locations?include_child_accounts=true`, {
            headers: auth.getAuthHeaders()
        });

        const locations = response.locations || [];
        const selectElement = document.getElementById(`input-${elementId}`);
        
        console.log('loadLocationsForSelect:', {
            elementId,
            dataKey,
            locationsCount: locations.length,
            rawLocations: locations,  // Show full objects
            firstLocationKeys: locations.length > 0 ? Object.keys(locations[0]) : [],
            selectElement: selectElement ? 'found' : 'not found'
        });
        
        if (selectElement) {
            const savedValue = reportCreationState.formData.info[dataKey];
            selectElement.innerHTML = `
                <option value="">Select location...</option>
                ${locations.map(loc => `
                    <option value="${loc.id}" data-name="${escapeHtml(loc.name)}" ${savedValue === loc.id ? 'selected' : ''}>
                        ${loc.name}
                    </option>
                `).join('')}
            `;
            
            // Add event listener to save location object (not just ID)
            selectElement.addEventListener('change', function() {
                const selectedOption = this.options[this.selectedIndex];
                if (this.value) {
                    const locationData = {
                        id: this.value,
                        name: selectedOption.getAttribute('data-name')
                    };
                    reportCreationState.formData.location = locationData;
                    reportCreationState.formData.info[dataKey] = this.value;
                    console.log('Location saved:', locationData);
                    window.updateLocationContacts(this.value);
                } else {
                    reportCreationState.formData.location = null;
                    reportCreationState.formData.info[dataKey] = '';
                    window.updateLocationContacts('');
                }
            });
            
            // Manually trigger for initial value
            if (selectElement.value) {
                console.log('Initial location value:', selectElement.value);
                const selectedOption = selectElement.options[selectElement.selectedIndex];
                const locationData = {
                    id: selectElement.value,
                    name: selectedOption.getAttribute('data-name')
                };
                reportCreationState.formData.location = locationData;
                window.updateLocationContacts(selectElement.value);
            }
        }
    } catch (error) {
        console.error('Failed to load locations:', error);
        const selectElement = document.getElementById(`input-${elementId}`);
        if (selectElement) {
            selectElement.innerHTML = '<option value="">Error loading locations</option>';
        }
    }
}

/**
 * Load users for select dropdown
 */
async function loadUsersForSelect(elementId, dataKey) {
    try {
        const userData = getCurrentUser();
        const accountId = getEffectiveAccountId();
        if (!userData || !accountId) return;

        const response = await apiCall(`/users/?account_id=${accountId}&include_child_accounts=true&role=External contact`, {
            headers: auth.getAuthHeaders()
        });

        const users = response.users || [];
        const selectElement = document.getElementById(`input-${elementId}`);
        
        if (selectElement) {
            const savedValue = reportCreationState.formData.info[dataKey];
            selectElement.innerHTML = `
                <option value="">Select user...</option>
                ${users.map(user => `
                    <option value="${user._id}" ${savedValue === user._id ? 'selected' : ''}>
                        ${user.full_name || user.name || user.username}
                    </option>
                `).join('')}
            `;
        }
    } catch (error) {
        console.error('Failed to load users:', error);
        const selectElement = document.getElementById(`input-${elementId}`);
        if (selectElement) {
            selectElement.innerHTML = '<option value="">Error loading users</option>';
        }
    }
}

/**
 * Load tags for selection
 */
async function loadTagsForSelect(elementId, dataKey, config) {
    try {
        const userData = getCurrentUser();
        const accountId = getEffectiveAccountId();
        if (!userData || !accountId) return;

        const response = await apiCall(`/tags/structure?account_id=${accountId}`, {
            headers: auth.getAuthHeaders()
        });

        const structure = response.structure || [];
        const categoryId = config?.categoryId;
        const allowMultiple = config?.allowMultiple || false;
        
        // Find the selected category
        const category = structure.find(cat => cat.id === categoryId);
        const tags = category ? (category.children || []) : [];
        
        const containerElement = document.getElementById(`input-${elementId}`);
        
        if (containerElement) {
            const savedValue = reportCreationState.formData.info[dataKey];
            const savedTags = savedValue ? (Array.isArray(savedValue) ? savedValue : [savedValue]) : [];
            
            if (tags.length === 0) {
                containerElement.innerHTML = `
                    <p class="text-sm text-gray-500 italic">No tags available in this category</p>
                `;
            } else if (allowMultiple) {
                // Render as checkboxes for multiple selection
                containerElement.innerHTML = `
                    <div class="space-y-2">
                        ${tags.map(tag => {
                            const tagColor = tag.color || '#6B7280';
                            const isChecked = savedTags.includes(String(tag.id));
                            return `
                                <label class="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <input type="checkbox" 
                                           value="${tag.id}"
                                           ${isChecked ? 'checked' : ''}
                                           onchange="window.updateTagSelection('${dataKey}', ${allowMultiple})"
                                           class="rounded border-gray-300 text-primary-600 focus:ring-primary-500 mr-3">
                                    <span class="inline-flex items-center px-2 py-1 rounded text-xs font-medium" 
                                          style="background-color: ${tagColor}20; color: ${tagColor}; border: 1px solid ${tagColor}40;">
                                        ${escapeHtml(tag.name)}
                                    </span>
                                </label>
                            `;
                        }).join('')}
                    </div>
                `;
            } else {
                // Render as radio buttons for single selection
                containerElement.innerHTML = `
                    <div class="space-y-2">
                        ${tags.map(tag => {
                            const tagColor = tag.color || '#6B7280';
                            const isChecked = savedTags.includes(String(tag.id));
                            return `
                                <label class="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <input type="radio" 
                                           name="tag-${elementId}"
                                           value="${tag.id}"
                                           ${isChecked ? 'checked' : ''}
                                           onchange="window.updateTagSelection('${dataKey}', ${allowMultiple})"
                                           class="border-gray-300 text-primary-600 focus:ring-primary-500 mr-3">
                                    <span class="inline-flex items-center px-2 py-1 rounded text-xs font-medium" 
                                          style="background-color: ${tagColor}20; color: ${tagColor}; border: 1px solid ${tagColor}40;">
                                        ${escapeHtml(tag.name)}
                                    </span>
                                </label>
                            `;
                        }).join('')}
                    </div>
                `;
            }
        }
    } catch (error) {
        console.error('Failed to load tags:', error);
        const containerElement = document.getElementById(`input-${elementId}`);
        if (containerElement) {
            containerElement.innerHTML = '<p class="text-sm text-red-500">Error loading tags</p>';
        }
    }
}

/**
 * Update tag selection in form data
 */
window.updateTagSelection = function(dataKey, allowMultiple) {
    const checkboxes = document.querySelectorAll(`input[type="${allowMultiple ? 'checkbox' : 'radio'}"][onchange*="${dataKey}"]`);
    const selectedTags = [];
    
    checkboxes.forEach(cb => {
        if (cb.checked) {
            selectedTags.push(cb.value);
        }
    });
    
    // Store as array if multiple, single value if not
    reportCreationState.formData.info[dataKey] = allowMultiple ? selectedTags : (selectedTags[0] || '');
};

/**
 * Update report title
 */
function updateReportTitle(value) {
    reportCreationState.currentReport.title = value;
}

/**
 * Update form data
 */
function updateFormData(section, key, value) {
    if (section === 'info') {
        reportCreationState.formData.info[key] = value;
    }
}
// Cache for users data to avoid duplicate concurrent API calls
let usersDataCache = null;
let usersCacheTimestamp = null;
const USERS_CACHE_DURATION = 30000; // 30 seconds

/**
 * Update location contacts display based on selected location
 */
async function updateLocationContacts(locationId) {
    try {
        // Find all location-contacts elements
        const contactsElements = document.querySelectorAll('[id^="location-contacts-"]');
        
        // Debug logging
        console.log('updateLocationContacts called with:', locationId, 'type:', typeof locationId);
        
        // Check for empty, undefined, or the string "undefined"
        if (!locationId || locationId.trim() === '' || locationId === 'undefined') {
            // Clear contacts if no location selected
            console.log('No location ID, clearing contacts');
            contactsElements.forEach(el => {
                el.innerHTML = '<p class="italic">Select a location to view external users</p>';
            });
            return;
        }

        // Fetch location details to get contact_user_ids
        console.log('Fetching location details for ID:', locationId);
        const location = await apiCall(`/locations/${locationId}`, {
            headers: auth.getAuthHeaders()
        });

        console.log('Location response:', {
            hasLocation: !!location,
            locationKeys: location ? Object.keys(location) : [],
            contact_user_ids: location?.contact_user_ids,
            external_users: location?.external_users
        });

        const contactUserIds = location.contact_user_ids || [];
        
        if (contactUserIds.length === 0) {
            contactsElements.forEach(el => {
                el.innerHTML = '<p class="italic">No external users assigned to this location</p>';
            });
            return;
        }

        // Fetch user details for all external users
        // Check cache first to avoid duplicate requests
        const now = Date.now();
        let usersResponse;
        
        if (usersDataCache && usersCacheTimestamp && (now - usersCacheTimestamp < USERS_CACHE_DURATION)) {
            console.log('Using cached users data');
            usersResponse = usersDataCache;
        } else {
            // Add delay to ensure previous request fully completes
            console.log('About to fetch users (after 500ms delay)...');
            await new Promise(resolve => setTimeout(resolve, 500)); // 500ms delay
            
            try {
                console.log('Starting users API call now...');
                const userData = getCurrentUser();
                const accountId = getEffectiveAccountId();
                if (!accountId) return;
                
                usersResponse = await apiCall(`/users/?account_id=${accountId}&include_child_accounts=true&role=External contact`, {
                    headers: auth.getAuthHeaders()
                });
                console.log('Users API response:', usersResponse);
                
                // Cache the response
                usersDataCache = usersResponse;
                usersCacheTimestamp = now;
            } catch (error) {
                console.error('Error fetching users:', error);
                contactsElements.forEach(el => {
                    el.innerHTML = '<p class="italic text-red-600">Error loading users: ' + error.message + '</p>';
                });
                return;
            }
        }
        
        const allUsers = usersResponse.users || [];
        console.log('Users fetched:', {
            totalUsers: allUsers.length,
            firstUserKeys: allUsers.length > 0 ? Object.keys(allUsers[0]) : [],
            contactUserIds: contactUserIds,
            sampleUserId: allUsers.length > 0 ? (allUsers[0]._id || allUsers[0].id) : 'none'
        });
        
        const contactUsers = allUsers.filter(user => contactUserIds.includes(user._id || user.id));
        console.log('Filtered contact users:', contactUsers);

        if (contactUsers.length === 0) {
            contactsElements.forEach(el => {
                el.innerHTML = '<p class="italic">No external users found</p>';
            });
            return;
        }

        // Display external user names
        const contactsHtml = `
            <ul class="list-disc list-inside space-y-1">
                ${contactUsers.map(user => `
                    <li>${user.full_name || user.name || user.username}</li>
                `).join('')}
            </ul>
        `;

        contactsElements.forEach(el => {
            el.innerHTML = contactsHtml;
        });

    } catch (error) {
        console.error('Failed to load external users:', error);
        const contactsElements = document.querySelectorAll('[id^="location-contacts-"]');
        contactsElements.forEach(el => {
            el.innerHTML = '<p class="text-red-600">Error loading external users</p>';
        });
    }
}

/**
 * Open documentation entry editor
 */
function openDocumentationEntry(elementId, index, structurePath) {
    console.log('🔵 openDocumentationEntry called with:', { elementId, index, structurePath });
    
    const template = reportCreationState.currentReport.template;
    const elements = template.elements || [];
    const docElement = elements.find(el => el.id === elementId || el._id === elementId);
    
    console.log('Found doc element:', docElement);
    
    if (!docElement) {
        console.error('❌ Documentation element not found');
        showError('Documentation element not found');
        return;
    }

    const isEvaluation = docElement.elementType === 'evaluation-input';
    const isNew = index === -1;
    const existingEntry = isNew ? null : reportCreationState.formData.documentation[index];

    // Create modal
    const modal = document.createElement('div');
    modal.className = 'fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50';
    modal.id = 'documentation-modal';
    
    const evalConfig = docElement.config || {};
    const scaleMin = evalConfig.scaleMin || 0;
    const scaleMax = evalConfig.scaleMax || 10;
    const allowNotRelevant = evalConfig.allowNotRelevant || false;

    modal.innerHTML = `
        <div class="relative top-20 mx-auto p-5 border w-11/12 max-w-4xl shadow-lg rounded-md bg-white">
            <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-medium text-gray-900">
                    ${isNew ? 'Add' : 'Edit'} Documentation Entry
                    ${structurePath ? `<span class="text-sm font-normal text-gray-500 ml-2">for ${structurePath}</span>` : ''}
                </h3>
                <button onclick="window.closeDocumentationModal()" class="text-gray-400 hover:text-gray-500">
                    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <div class="space-y-4">
                ${isEvaluation ? `
                    <!-- Evaluation Score -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            ${docElement.introText || 'Evaluation Score'}
                        </label>
                        <div class="flex flex-wrap gap-2">
                            ${Array.from({length: scaleMax - scaleMin + 1}, (_, i) => {
                                const score = scaleMin + i;
                                // Convert existingEntry.evaluation to number for comparison
                                const savedEval = existingEntry?.evaluation ? Number(existingEntry.evaluation) : null;
                                const isSelected = savedEval === score;
                                return `
                                    <button type="button" 
                                            id="score-${score}"
                                            onclick="window.selectEvaluationScore(${score})"
                                            class="px-4 py-2 border rounded-md hover:bg-gray-50 ${isSelected ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-700 border-gray-300'}">
                                        ${score}
                                    </button>
                                `;
                            }).join('')}
                            ${allowNotRelevant ? `
                                <button type="button" 
                                        id="score-na"
                                        onclick="window.selectEvaluationScore('N/A')"
                                        class="px-4 py-2 border rounded-md hover:bg-gray-50 ${existingEntry?.evaluation === 'N/A' ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-700 border-gray-300'}">
                                    Not Relevant
                                </button>
                            ` : ''}
                        </div>
                        <input type="hidden" id="selected-score" value="${existingEntry?.evaluation || ''}">
                    </div>
                ` : ''}

                <!-- Text Description -->
                <div>
                    <label for="doc-text" class="block text-sm font-medium text-gray-700 mb-2">
                        Description
                    </label>
                    <textarea id="doc-text" rows="4" 
                              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                              placeholder="Enter description...">${existingEntry?.text || ''}</textarea>
                </div>

                <!-- Images -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        Images (optional)
                    </label>
                    <div id="doc-images-container" class="grid grid-cols-4 gap-2">
                        ${existingEntry?.images ? existingEntry.images.map((img, imgIndex) => {
                            // Handle both old format (string) and new format (object)
                            let thumbnailUrl, fullUrl;
                            if (typeof img === 'string') {
                                // Old format: just a URL string
                                fullUrl = img;
                                thumbnailUrl = img.replace('/full/', '/thumb/');
                            } else if (typeof img === 'object' && img !== null) {
                                // New format: object with serverUrl, thumbnail, etc.
                                fullUrl = img.serverUrl || img.url;
                                thumbnailUrl = img.thumbnail || fullUrl;
                            }
                            
                            // Convert relative URLs to absolute using current origin
                            if (thumbnailUrl && !thumbnailUrl.startsWith('http')) {
                                thumbnailUrl = window.location.origin + thumbnailUrl;
                            }
                            if (fullUrl && !fullUrl.startsWith('http')) {
                                fullUrl = window.location.origin + fullUrl;
                            }
                            
                            return `
                            <div class="relative group" data-image-index="${imgIndex}">
                                <img src="${thumbnailUrl}" 
                                     onclick="window.viewFullImage('${fullUrl}')"
                                     class="h-24 w-24 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                                     alt="Documentation image ${imgIndex + 1}">
                                <button onclick="window.removeDocImage(${imgIndex})" 
                                        class="absolute top-1 right-1 bg-red-600 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        `}).join('') : ''}
                    </div>
                    <button onclick="window.addDocImage()" 
                            class="mt-2 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                        <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Add Image
                    </button>
                    <input type="file" id="doc-image-input" accept="image/*" class="hidden" onchange="window.handleDocImageUpload(event)">
                </div>
            </div>

            <!-- Actions -->
            <div class="mt-6 flex justify-end space-x-3">
                <button onclick="window.closeDocumentationModal()" 
                        class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                    Cancel
                </button>
                <button onclick="window.saveDocumentationEntry(${index}, '${structurePath || ''}')" 
                        class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700">
                    ${isNew ? 'Add Entry' : 'Save Changes'}
                </button>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    // Store temporary image data
    window.docModalImages = existingEntry?.images ? [...existingEntry.images] : [];
}

/**
 * Edit documentation entry
 */
function editDocumentationEntry(elementId, index) {
    openDocumentationEntry(elementId, index, null);
}

/**
 * Delete documentation entry
 */
function deleteDocumentationEntry(index) {
    reportCreationState.formData.documentation.splice(index, 1);
    renderTabContent();
}

/**
 * Close documentation modal
 */
function closeDocumentationModal() {
    const modal = document.getElementById('documentation-modal');
    if (modal) {
        modal.remove();
    }
    window.docModalImages = null;
}

/**
 * Select evaluation score
 */
function selectEvaluationScore(score) {
    console.log('🎯 Selecting evaluation score:', score, 'Type:', typeof score);
    
    // Deselect all
    document.querySelectorAll('[id^="score-"]').forEach(btn => {
        btn.classList.remove('bg-primary-600', 'text-white', 'border-primary-600');
        btn.classList.add('bg-white', 'text-gray-700', 'border-gray-300');
    });
    
    // Select clicked one - handle "N/A" special case
    const buttonId = score === 'N/A' ? 'score-na' : `score-${score}`;
    const btn = document.getElementById(buttonId);
    console.log('Looking for button:', buttonId, 'Found:', !!btn);
    
    if (btn) {
        btn.classList.remove('bg-white', 'text-gray-700', 'border-gray-300');
        btn.classList.add('bg-primary-600', 'text-white', 'border-primary-600');
    }
    
    const hiddenInput = document.getElementById('selected-score');
    if (hiddenInput) {
        hiddenInput.value = score;
        console.log('Set hidden input value to:', score);
    }
}

/**
 * Add image to documentation entry
 */
function addDocImage() {
    document.getElementById('doc-image-input').click();
}

/**
 * Handle image upload
 */
function handleDocImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = function(e) {
        window.docModalImages = window.docModalImages || [];
        window.docModalImages.push(e.target.result);
        updateDocImagesDisplay();
    };
    reader.readAsDataURL(file);
    
    // Reset input
    event.target.value = '';
}

/**
 * Remove image from documentation entry
 */
function removeDocImage(imgIndex) {
    window.docModalImages.splice(imgIndex, 1);
    updateDocImagesDisplay();
}

/**
 * Update images display in modal
 */
function updateDocImagesDisplay() {
    const container = document.getElementById('doc-images-container');
    if (!container) return;

    const images = window.docModalImages || [];
    
    container.innerHTML = images.map((img, imgIndex) => `
        <div class="flex items-center space-x-2 p-2 border rounded" data-image-index="${imgIndex}">
            <img src="${img}" class="h-20 w-20 object-cover rounded">
            <span class="flex-1 text-sm text-gray-600">Image ${imgIndex + 1}</span>
            <button onclick="removeDocImage(${imgIndex})" class="text-red-600 hover:text-red-700">
                <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
            </button>
        </div>
    `).join('');
}

/**
 * Save documentation entry
 */
function saveDocumentationEntry(index, structurePath) {
    const text = document.getElementById('doc-text').value.trim();
    const selectedScore = document.getElementById('selected-score');
    const evaluationRaw = selectedScore ? selectedScore.value : null;
    
    // Convert to number if it's a numeric value, keep as string if it's "N/A"
    let evaluation = null;
    if (evaluationRaw && evaluationRaw !== '') {
        evaluation = evaluationRaw === 'N/A' ? 'N/A' : Number(evaluationRaw);
    }

    console.log('💾 Saving documentation entry:');
    console.log('   Text:', text);
    console.log('   Evaluation (raw):', evaluationRaw);
    console.log('   Evaluation (converted):', evaluation, 'Type:', typeof evaluation);
    console.log('   Selected score element:', selectedScore);
    console.log('   Selected score value:', selectedScore?.value);

    if (!text) {
        showError('Please enter a description');
        return;
    }

    const entry = {
        text: text,
        images: window.docModalImages || [],
        structurePath: structurePath || null
    };

    if (evaluation !== null) {
        entry.evaluation = evaluation;
        console.log('   ✅ Adding evaluation to entry:', evaluation, 'Type:', typeof evaluation);
    } else {
        console.log('   ⚠️ No evaluation to save (empty or null)');
    }

    console.log('   Final entry object:', entry);

    if (index === -1) {
        // Add new entry
        reportCreationState.formData.documentation.push(entry);
        console.log('   Added new entry at index:', reportCreationState.formData.documentation.length - 1);
    } else {
        // Update existing entry
        reportCreationState.formData.documentation[index] = entry;
        console.log('   Updated entry at index:', index);
    }

    console.log('   All documentation entries:', reportCreationState.formData.documentation);

    closeDocumentationModal();
    renderTabContent();
    showSuccess('Documentation entry saved');
}

/**
 * Save report as draft
 */
async function saveReportDraft() {
    console.log('Save draft:', reportCreationState.currentReport);
    
    try {
        const currentUser = getCurrentUser();
        if (!currentUser || !currentUser.account_id) {
            showError('User not authenticated');
            return;
        }
        
        // Prepare documentation based on template type
        let documentation;
        if (reportCreationState.currentReport.template.documentation_layout === 'dynamic') {
            // For dynamic templates, flatten all zone entries into documentation array
            documentation = [];
            Object.keys(reportCreationState.formData.dynamicDocumentation || {}).forEach(zoneName => {
                const entries = reportCreationState.formData.dynamicDocumentation[zoneName];
                entries.forEach(entry => {
                    documentation.push({
                        ...entry,
                        zone: zoneName // Keep track of which zone this entry belongs to
                    });
                });
            });
        } else {
            // For structured templates, use existing documentation array
            documentation = reportCreationState.formData.documentation || [];
        }
        
        // Prepare report data
        const reportData = {
            title: reportCreationState.currentReport.title || 'Untitled Report',
            template_id: reportCreationState.currentReport.template_id,
            template_name: reportCreationState.currentReport.template_name,
            template: reportCreationState.currentReport.template,
            account_id: currentUser.account_id,
            status: 'draft',
            form_data: reportCreationState.formData,
            documentation: documentation
        };
        
        // Check if this is an update or new report
        if (reportCreationState.currentReport._id) {
            // Update existing report
            const response = await apiCall(`/reports/${reportCreationState.currentReport._id}`, {
                method: 'PUT',
                headers: auth.getAuthHeaders(),
                body: JSON.stringify(reportData)
            });
            
            showSuccess('Draft saved successfully');
            reportCreationState.currentReport = response;
        } else {
            // Create new report
            const response = await apiCall('/reports/', {
                method: 'POST',
                headers: auth.getAuthHeaders(),
                body: JSON.stringify(reportData)
            });
            
            showSuccess('Draft saved successfully');
            reportCreationState.currentReport = response;
        }
        
        // Close modal and refresh list
        closeReportEditDialog();
        await window.filterReports();
    } catch (error) {
        console.error('Failed to save draft:', error);
        showError('Failed to save draft: ' + (error.message || 'Unknown error'));
    }
}

/**
 * Publish report
 */
async function publishReport() {
    console.log('Publish report:', reportCreationState.currentReport);
    
    try {
        const currentUser = getCurrentUser();
        if (!currentUser || !currentUser.account_id) {
            showError('User not authenticated');
            return;
        }
        
        // Validate required fields
        if (!reportCreationState.formData.location) {
            showError('Please select a location');
            return;
        }
        
        // Prepare documentation based on template type
        let documentation;
        if (reportCreationState.currentReport.template.documentation_layout === 'dynamic') {
            // For dynamic templates, flatten all zone entries into documentation array
            documentation = [];
            Object.keys(reportCreationState.formData.dynamicDocumentation || {}).forEach(zoneName => {
                const entries = reportCreationState.formData.dynamicDocumentation[zoneName];
                entries.forEach(entry => {
                    documentation.push({
                        ...entry,
                        zone: zoneName // Keep track of which zone this entry belongs to
                    });
                });
            });
        } else {
            // For structured templates, use existing documentation array
            documentation = reportCreationState.formData.documentation || [];
        }
        
        // Prepare report data
        const reportData = {
            title: reportCreationState.currentReport.title || 'Untitled Report',
            template_id: reportCreationState.currentReport.template_id,
            template_name: reportCreationState.currentReport.template_name,
            template: reportCreationState.currentReport.template,
            account_id: currentUser.account_id,
            status: 'published',
            form_data: reportCreationState.formData,
            documentation: documentation
        };
        
        // Check if this is an update or new report
        if (reportCreationState.currentReport._id) {
            // Update existing report
            const response = await apiCall(`/reports/${reportCreationState.currentReport._id}`, {
                method: 'PUT',
                headers: auth.getAuthHeaders(),
                body: JSON.stringify(reportData)
            });
            
            showSuccess('Report published successfully');
        } else {
            // Create new report as published
            const response = await apiCall('/reports/', {
                method: 'POST',
                headers: auth.getAuthHeaders(),
                body: JSON.stringify(reportData)
            });
            
            showSuccess('Report published successfully');
        }
        
        // Close modal and refresh list
        closeReportEditDialog();
        await window.filterReports();
    } catch (error) {
        console.error('Failed to publish report:', error);
        showError('Failed to publish report: ' + (error.message || 'Unknown error'));
    }
}

/**
 * View a report (read-only) - Opens preview modal with generated report
 */
async function viewReport(reportId) {
    try {
        const report = await apiCall(`/reports/${reportId}`, {
            headers: auth.getAuthHeaders()
        });
        
        // Fetch locations and users for lookup
        const userData = getCurrentUser();
        const accountId = getEffectiveAccountId();
        if (!accountId) {
            showError('Please select an account first');
            return;
        }
        
        const [locationsResp, usersResp] = await Promise.all([
            apiCall(`/locations?include_child_accounts=true`, {
                headers: auth.getAuthHeaders()
            }),
            apiCall(`/users/?account_id=${accountId}&include_child_accounts=true`, {
                headers: auth.getAuthHeaders()
            })
        ]);
        
        // Create lookup maps
        const locationsMap = {};
        (locationsResp.locations || []).forEach(loc => {
            locationsMap[loc.id] = loc;
        });
        
        const usersMap = {};
        (usersResp.users || []).forEach(user => {
            usersMap[user._id] = user;
        });
        
        // Find location ID from form data to fetch external users
        let selectedLocationId = null;
        if (report.form_data && report.form_data.info) {
            // Look for location ID in form data (before enrichment)
            for (const key in report.form_data.info) {
                const value = report.form_data.info[key];
                if (typeof value === 'string' && locationsMap[value]) {
                    selectedLocationId = value;
                    break;
                }
            }
        }
        
        // Fetch location contacts if a location is selected
        let locationContacts = [];
        if (selectedLocationId) {
            try {
                const location = await apiCall(`/locations/${selectedLocationId}`, {
                    headers: auth.getAuthHeaders()
                });
                const contactUserIds = location.contact_user_ids || [];
                // Get the actual user objects for the contacts
                locationContacts = contactUserIds.map(userId => usersMap[userId]).filter(Boolean);
            } catch (error) {
                console.error('Failed to fetch location contacts:', error);
            }
        }
        
        // Enrich report data: convert location/user IDs to objects with names
        if (report.form_data && report.form_data.info) {
            const enrichedInfo = {};
            Object.keys(report.form_data.info).forEach(key => {
                const value = report.form_data.info[key];
                enrichedInfo[key] = value;
                
                // Check if this looks like a location ID (check if it exists in locationsMap)
                if (typeof value === 'string' && locationsMap[value]) {
                    enrichedInfo[key] = locationsMap[value].name;
                }
                // Check if this looks like a user ID (check if it exists in usersMap)
                else if (typeof value === 'string' && usersMap[value]) {
                    enrichedInfo[key] = usersMap[value].full_name || usersMap[value].name || usersMap[value].username;
                }
            });
            report.form_data.info = enrichedInfo;
        }
        
        // Add creator name to report metadata
        if (report.created_by && usersMap[report.created_by]) {
            report.creator_name = usersMap[report.created_by].full_name || 
                                  usersMap[report.created_by].name || 
                                  usersMap[report.created_by].username;
        }
        
        // Add location contacts to report
        report.location_contacts = locationContacts;
        
        // Import and use the template preview system from report-templates module
        // We'll pass the report data to generate a real preview instead of dummy data
        showReportGeneratedPreview(report);
    } catch (error) {
        console.error('Failed to load report:', error);
        showError('Failed to load report: ' + (error.message || 'Unknown error'));
    }
}

/**
 * Show generated report preview (uses same rendering as template preview but with real data)
 */
function showReportGeneratedPreview(report) {
    const templateName = report.title || report.template_name || 'Report';
    const reportData = report.form_data || {};
    
    // Add documentation from report (stored separately from form_data)
    if (report.documentation) {
        reportData.documentation = report.documentation;
    }
    
    // Add creator_name from report metadata to reportData so it's available in rendering
    if (report.creator_name) {
        reportData.creator_name = report.creator_name;
    }
    
    // Add location_contacts from report metadata to reportData
    if (report.location_contacts) {
        reportData.location_contacts = report.location_contacts;
    }
    
    // Create preview modal with same structure as template preview
    const modal = document.createElement('div');
    modal.className = 'preview-modal';
    modal.innerHTML = `
        <style>
            @media print {
                body > *:not(.preview-modal) {
                    display: none !important;
                }
                .preview-modal {
                    position: static !important;
                    background: white !important;
                    padding: 0 !important;
                    overflow: visible !important;
                }
                .preview-container {
                    max-width: none !important;
                    margin: 0 !important;
                    box-shadow: none !important;
                    border-radius: 0 !important;
                }
                .preview-header {
                    display: none !important;
                }
                .preview-body {
                    padding: 0 !important;
                    max-height: none !important;
                    overflow: visible !important;
                }
                .preview-pages {
                    display: block !important;
                }
                .preview-page {
                    page-break-after: always;
                    margin: 0 !important;
                }
                .preview-page:last-child {
                    page-break-after: auto;
                }
                .preview-page-label {
                    display: none !important;
                }
            }
        </style>
        <div class="preview-container">
            <div class="preview-header">
                <h2 class="preview-title">${escapeHtml(templateName)}</h2>
                <div class="preview-actions">
                    <button onclick="window.downloadReportPDF('${report._id}', '${escapeHtml(templateName)}')" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                        <svg class="-ml-1 mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        Download PDF
                    </button>
                    ${report.status === 'draft' ? `
                        <button onclick="window.closeReportGeneratedPreview(); window.editReport('${report._id}')" class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700">
                            Edit Report
                        </button>
                    ` : ''}
                    <button onclick="window.closeReportGeneratedPreview()" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                        <svg class="-ml-1 mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        Close
                    </button>
                </div>
            </div>
            <div class="preview-body">
                <div class="preview-pages" id="preview-pages-container"></div>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    
    // Render report pages with real data
    renderReportPages(report);
    
    // Close on background click
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            closeReportGeneratedPreview();
        }
    });
    
    // Close on Escape key
    const escapeHandler = (e) => {
        if (e.key === 'Escape') {
            closeReportGeneratedPreview();
            document.removeEventListener('keydown', escapeHandler);
        }
    };
    document.addEventListener('keydown', escapeHandler);
}

/**
 * Render all pages in generated report with real data
 */
function renderReportPages(report) {
    const container = document.getElementById('preview-pages-container');
    if (!container || !report.template || !report.template.elements) return;
    
    const elements = report.template.elements;
    const pages = ['frontpage', 'results', 'data', 'conclusion'];
    const pageLabels = {
        'frontpage': 'Front Page',
        'results': 'Results',
        'data': 'Documentation',
        'conclusion': 'Final Remarks'
    };
    
    container.innerHTML = '';
    
    // Track global input element index across all pages
    let globalInputIndex = 0;
    
    pages.forEach(page => {
        const pageElements = elements.filter(el => (el.page || el.element_page) === page);
        
        // Only render page if it has elements
        if (pageElements.length > 0) {
            const pageDiv = document.createElement('div');
            pageDiv.className = 'preview-page';
            pageDiv.innerHTML = `<div class="preview-page-label">${pageLabels[page]}</div>`;
            
            // Render page content based on page type, passing and getting back the global index
            const result = renderReportPageContent(page, pageElements, report, globalInputIndex);
            pageDiv.innerHTML += result.html;
            globalInputIndex = result.nextIndex;
            
            container.appendChild(pageDiv);
        }
    });
    
    if (container.children.length === 0) {
        container.innerHTML = '<div class="text-white text-center py-8">No content to display</div>';
    }
}

/**
 * Render content for a specific report page with real data
 */
function renderReportPageContent(page, elements, report, startIndex) {
    const reportData = report.form_data || {};
    
    console.log('📄 renderReportPageContent:', {
        page,
        elementsCount: elements.length,
        hasFormData: !!report.form_data,
        formDataKeys: report.form_data ? Object.keys(report.form_data) : [],
        infoKeys: report.form_data?.info ? Object.keys(report.form_data.info) : [],
        startIndex
    });
    
    if (page === 'frontpage') {
        return renderReportFrontPage(elements, reportData, startIndex);
    } else if (page === 'results') {
        return renderReportResultsPage(elements, reportData, startIndex);
    } else if (page === 'data') {
        // Data page doesn't use input indexing, return unchanged index
        return { html: renderReportDataPage(elements, reportData), nextIndex: startIndex };
    } else if (page === 'conclusion') {
        return renderReportConclusionPage(elements, reportData, startIndex);
    }
    return { html: '', nextIndex: startIndex };
}

/**
 * Render front page with real data
 */
function renderReportFrontPage(elements, reportData, startIndex = 0) {
    const zones = {
        'header-left': [], 'header-right': [], 'main-content': [],
        'headline-left': [], 'headline-right': [], 'detail-1': [],
        'detail-2': [], 'detail-3': [], 'detail-4': [],
        'footer-left': [], 'footer-right': []
    };
    
    elements.forEach(el => {
        if (zones[el.zone]) {
            zones[el.zone].push(el);
        }
    });
    
    let idx = startIndex;
    const headerLeft = renderReportZoneElements(zones['header-left'], reportData, idx);
    idx = headerLeft.nextIndex;
    const headerRight = renderReportZoneElements(zones['header-right'], reportData, idx);
    idx = headerRight.nextIndex;
    const mainContent = renderReportZoneElements(zones['main-content'], reportData, idx);
    idx = mainContent.nextIndex;
    const headlineLeft = renderReportZoneElements(zones['headline-left'], reportData, idx);
    idx = headlineLeft.nextIndex;
    const headlineRight = renderReportZoneElements(zones['headline-right'], reportData, idx);
    idx = headlineRight.nextIndex;
    const detail1 = renderReportZoneElements(zones['detail-1'], reportData, idx);
    idx = detail1.nextIndex;
    const detail2 = renderReportZoneElements(zones['detail-2'], reportData, idx);
    idx = detail2.nextIndex;
    const detail3 = renderReportZoneElements(zones['detail-3'], reportData, idx);
    idx = detail3.nextIndex;
    const detail4 = renderReportZoneElements(zones['detail-4'], reportData, idx);
    idx = detail4.nextIndex;
    const footerLeft = renderReportZoneElements(zones['footer-left'], reportData, idx);
    idx = footerLeft.nextIndex;
    const footerRight = renderReportZoneElements(zones['footer-right'], reportData, idx);
    
    const html = `
        <div class="preview-header-zones">
            <div class="preview-zone">${headerLeft.html}</div>
            <div class="preview-zone">${headerRight.html}</div>
        </div>
        <div class="preview-zone">${mainContent.html}</div>
        <div class="preview-headline-zones">
            <div class="preview-zone">${headlineLeft.html}</div>
            <div class="preview-zone">${headlineRight.html}</div>
        </div>
        <div class="preview-detail-zones">
            <div class="preview-zone">${detail1.html}</div>
            <div class="preview-zone">${detail2.html}</div>
            <div class="preview-zone">${detail3.html}</div>
            <div class="preview-zone">${detail4.html}</div>
        </div>
        <div class="preview-footer-zones">
            <div class="preview-zone">${footerLeft.html}</div>
            <div class="preview-zone">${footerRight.html}</div>
        </div>
    `;
    
    return { html, nextIndex: idx };
}

/**
 * Render results page with real data
 */
function renderReportResultsPage(elements, reportData, startIndex = 0) {
    const zones = {
        'results-top': [], 'results-upper': [], 'results-middle': [],
        'results-lower': [], 'results-bottom': []
    };
    
    elements.forEach(el => {
        if (zones[el.zone]) {
            zones[el.zone].push(el);
        }
    });
    
    let idx = startIndex;
    const resultsTop = renderReportZoneElements(zones['results-top'], reportData, idx);
    idx = resultsTop.nextIndex;
    const resultsUpper = renderReportZoneElements(zones['results-upper'], reportData, idx);
    idx = resultsUpper.nextIndex;
    const resultsMiddle = renderReportZoneElements(zones['results-middle'], reportData, idx);
    idx = resultsMiddle.nextIndex;
    const resultsLower = renderReportZoneElements(zones['results-lower'], reportData, idx);
    idx = resultsLower.nextIndex;
    const resultsBottom = renderReportZoneElements(zones['results-bottom'], reportData, idx);
    
    const html = `
        <div class="preview-zone">${resultsTop.html}</div>
        <div class="preview-zone">${resultsUpper.html}</div>
        <div class="preview-zone">${resultsMiddle.html}</div>
        <div class="preview-zone">${resultsLower.html}</div>
        <div class="preview-zone">${resultsBottom.html}</div>
    `;
    
    return { html, nextIndex: idx };
}

/**
 * Render data/documentation page with real entries
 */
function renderReportDataPage(elements, reportData) {
    const docElements = elements.filter(el => 
        (el.elementType || el.element_type) === 'evaluation-input' || 
        (el.elementType || el.element_type) === 'image-text-input'
    );
    
    if (docElements.length === 0) return '';
    
    const documentation = reportData.documentation || [];
    
    if (documentation.length === 0) {
        return '<div class="preview-zone" style="padding: 2rem; text-align: center; color: #9ca3af;">No documentation entries</div>';
    }
    
    // Render all documentation entries
    return `
        <div class="preview-zone">
            ${documentation.map((entry, index) => renderDocumentationEntry(entry, index + 1)).join('')}
        </div>
    `;
}

/**
 * Render a single documentation entry with header and content sections
 */
function renderDocumentationEntry(entry, number) {
    const score = entry.evaluation || entry.evaluation_score || entry.score;
    const hasScore = score !== undefined && score !== null && score !== '';
    
    // Determine score color and badge styling
    let scoreColor = '#9ca3af'; // gray default
    let scoreBgColor = '#f3f4f6'; // gray background
    if (hasScore) {
        if (score === '-' || score === 'N/A' || score === 'Not Relevant') {
            scoreColor = '#6b7280'; // gray text
            scoreBgColor = '#f3f4f6'; // gray bg
        } else {
            const numScore = Number(score);
            if (numScore <= 2) {
                scoreColor = '#ef4444'; // red text
                scoreBgColor = '#fee2e2'; // red bg
            } else if (numScore <= 3) {
                scoreColor = '#eab308'; // yellow text
                scoreBgColor = '#fef3c7'; // yellow bg
            } else {
                scoreColor = '#10b981'; // green text
                scoreBgColor = '#d1fae5'; // green bg
            }
        }
    }
    
    // Get the structure path from entry (stored as structurePath in saved data)
    const structurePath = entry.structurePath || entry.path || '';
    
    return `
        <div style="margin-bottom: 1.5rem; page-break-inside: avoid;">
            <!-- Header Row: Number | Label | Score -->
            <div style="display: grid; grid-template-columns: 2rem 1fr auto; gap: 0.75rem; align-items: center; background: #f3f4f6; padding: 0.5rem 0.75rem; border-radius: 0.375rem; margin-bottom: 0.75rem; border: 1px solid #e5e7eb;">
                <!-- Running Number -->
                <div style="width: 1.5rem; height: 1.5rem; background: #e5e7eb; border-radius: 9999px; font-weight: 600; font-size: 0.75rem; color: #374151; flex-shrink: 0; text-align: center; font-family: Arial, sans-serif; position: relative;"><span style="position: absolute; top: 0; left: 0; right: 0; line-height: 1;">${number}</span></div>
                
                <!-- Label from Structure -->
                <div style="font-size: 0.8125rem; font-weight: 600; color: #374151;">
                    ${structurePath ? escapeHtml(structurePath) : ''}
                </div>
                
                <!-- Evaluation Score -->
                ${hasScore ? `
                    <div style="min-width: 2.5rem; height: 1.75rem; padding: 0 0.75rem; background: ${scoreBgColor}; border-radius: 0.375rem; font-weight: 700; font-size: 1rem; color: ${scoreColor}; flex-shrink: 0; text-align: center; font-family: Arial, sans-serif; position: relative;"><span style="position: absolute; top: 0; left: 0; right: 0; line-height: 1;">${score}</span></div>
                ` : '<div style="width: 2.5rem;"></div>'}
            </div>
            
            <!-- Content Row: Text | Images -->
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                <!-- Text Column -->
                <div style="text-align: left;">
                    ${entry.text ? `<p style="font-size: 0.875rem; line-height: 1.5; color: #374151; margin: 0; white-space: pre-wrap; text-align: left;">${escapeHtml(entry.text)}</p>` : '<p style="font-size: 0.875rem; color: #9ca3af; margin: 0; font-style: italic; text-align: left;">No text provided</p>'}
                </div>
                
                <!-- Images Column -->
                <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                    ${entry.images && entry.images.length > 0 ? 
                        entry.images.map(img => {
                            // Handle both old format (string) and new format (object with serverUrl/thumbnail)
                            let imgUrl;
                            if (typeof img === 'string') {
                                imgUrl = img;
                            } else if (img.serverUrl) {
                                // Use full image for display, build absolute URL if needed
                                imgUrl = img.serverUrl;
                                if (!imgUrl.startsWith('http')) {
                                    imgUrl = window.location.origin + imgUrl;
                                }
                            } else if (img.url) {
                                imgUrl = img.url;
                            }
                            
                            const imgDesc = img.description || '';
                            return `
                                <div style="position: relative; width: 100%; background: #e5e7eb; border-radius: 0.375rem; overflow: hidden; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);">
                                    <img src="${imgUrl}" alt="${escapeHtml(imgDesc)}" 
                                         style="width: 100%; height: auto; display: block;">
                                    ${imgDesc ? `
                                        <div style="position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,0.75); color: white; font-size: 0.75rem; padding: 0.375rem 0.5rem; line-height: 1.2;">
                                            ${escapeHtml(imgDesc)}
                                        </div>
                                    ` : ''}
                                </div>
                            `;
                        }).join('') 
                    : `
                        <div style="width: 100%; height: 120px; background: #f3f4f6; border: 2px dashed #d1d5db; border-radius: 0.375rem; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                            <svg style="width: 40px; height: 40px; color: #9ca3af; margin-bottom: 0.5rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <span style="font-size: 0.75rem; color: #9ca3af;">No images</span>
                        </div>
                    `}
                </div>
            </div>
        </div>
    `;
}

/**
 * Render conclusion page with real data
 */
function renderReportConclusionPage(elements, reportData, startIndex = 0) {
    const zones = { 'conclusion-content': [] };
    
    elements.forEach(el => {
        if (zones[el.zone]) {
            zones[el.zone].push(el);
        }
    });
    
    const conclusionContent = renderReportZoneElements(zones['conclusion-content'], reportData, startIndex);
    const html = `<div class="preview-zone">${conclusionContent.html}</div>`;
    return { html, nextIndex: conclusionContent.nextIndex };
}

/**
 * Render zone elements with real data
 */
function renderReportZoneElements(elements, reportData, startIndex = 0) {
    if (elements.length === 0) return { html: '', nextIndex: startIndex };
    
    // Define which element types are input elements (vs static elements)
    const inputElementTypes = [
        'text-input', 'date-input', 'location-input', 'user-input',
        'image-input', 'statistics-input', 'creator-name', 'location-contacts'
    ];
    
    // Track the index among INPUT elements only, starting from provided index
    let inputElementIndex = startIndex;
    
    const html = elements.map(el => {
        const elementType = el.elementType || el.element_type;
        const isInputElement = inputElementTypes.includes(elementType);
        
        // Render the element, passing inputElementIndex only for input elements
        const rendered = renderReportElement(el, reportData, isInputElement ? inputElementIndex : undefined);
        
        // Increment counter only for input elements
        if (isInputElement) {
            inputElementIndex++;
        }
        
        return rendered;
    }).join('');
    
    return { html, nextIndex: inputElementIndex };
}

/**
 * Render a single element with real report data
 */
function renderReportElement(element, reportData, elementIndex) {
    const elementType = element.elementType || element.element_type;
    const elementId = element.id || element._id;
    const infoData = reportData.info || {};
    
    // Helper function to get value from info data with fallback logic
    const getInfoValue = (elId) => {
        // Try direct element ID first
        if (infoData[elId] !== undefined) {
            return infoData[elId];
        }
        
        // Fallback: Try sequential index key (current system)
        if (elementIndex !== undefined) {
            const fallbackKey = `element-${elementIndex}`;
            if (infoData[fallbackKey] !== undefined) {
                return infoData[fallbackKey];
            }
        }
        
        return undefined;
    };
    
    switch (elementType) {
        // Static elements - render as-is
        case 'heading':
            const headingText = element.staticData?.content || element.static_data?.content || 'Heading';
            const size = element.config?.size || 'medium';
            return `<div class="preview-element"><h2 class="preview-heading size-${size}">${escapeHtml(headingText)}</h2></div>`;
            
        case 'text-block':
            const blockText = element.staticData?.content || element.static_data?.content || '';
            return `<div class="preview-element"><div class="preview-text-block">${escapeHtml(blockText)}</div></div>`;
            
        case 'image':
            const imageData = element.staticData?.imageData || element.static_data?.imageData;
            const alignment = element.alignment || 'center';
            if (!imageData) return '';
            return `<div class="preview-element" style="text-align: ${alignment};"><div class="preview-image-wrapper" style="display: inline-block;"><img src="${imageData}" alt="Report image" class="preview-image" /></div></div>`;
            
        case 'divider':
            const style = element.config?.style || 'solid';
            return `<div class="preview-element"><hr class="preview-divider style-${style}" /></div>`;
            
        // Dynamic elements - use real data from report
        case 'text-input':
            const textValue = getInfoValue(elementId) || '';
            const textLabel = element.introText || element.intro_text || element.config?.label || '';
            if (!textValue) return '';
            return `
                <div class="preview-element">
                    ${textLabel ? `<div class="preview-input-label">${escapeHtml(textLabel)}</div>` : ''}
                    <div class="preview-text-block">${escapeHtml(textValue)}</div>
                </div>
            `;
            
        case 'date-input':
            const dateValue = getInfoValue(elementId) || '';
            const dateLabel = element.introText || element.intro_text || '';
            if (!dateValue) return '';
            console.log('📅 Date value for display:', dateValue, 'Has T:', dateValue.includes('T'));
            // Format datetime for display (from YYYY-MM-DDTHH:MM to readable format)
            let displayDate = dateValue;
            if (dateValue.includes('T')) {
                const [datePart, timePart] = dateValue.split('T');
                const [year, month, day] = datePart.split('-');
                const [hours, minutes] = timePart.split(':');
                displayDate = `${day}/${month}/${year} ${hours}:${minutes}`;
            } else {
                // Old format without time - just format the date
                const [year, month, day] = dateValue.split('-');
                displayDate = `${day}/${month}/${year}`;
            }
            return `
                <div class="preview-element">
                    ${dateLabel ? `<div class="preview-input-label">${escapeHtml(dateLabel)}</div>` : ''}
                    <div class="preview-text-block">${escapeHtml(displayDate)}</div>
                </div>
            `;
            
        case 'location-input':
            const locationValue = getInfoValue(elementId);
            const locationLabel = element.introText || element.intro_text || '';
            if (!locationValue) return '';
            // locationValue might be an object with name, or just a string
            const locationName = typeof locationValue === 'object' ? locationValue.name : locationValue;
            return `
                <div class="preview-element">
                    ${locationLabel ? `<div class="preview-input-label">${escapeHtml(locationLabel)}</div>` : ''}
                    <div class="preview-text-block">${escapeHtml(locationName)}</div>
                </div>
            `;
            
        case 'user-input':
            const userValue = getInfoValue(elementId);
            const userLabel = element.introText || element.intro_text || '';
            if (!userValue) return '';
            // userValue might be an object with full_name, or just a string
            const userName = typeof userValue === 'object' ? userValue.full_name || userValue.username : userValue;
            return `
                <div class="preview-element">
                    ${userLabel ? `<div class="preview-input-label">${escapeHtml(userLabel)}</div>` : ''}
                    <div class="preview-text-block">${escapeHtml(userName)}</div>
                </div>
            `;
            
        case 'tag-input':
            const tagValue = getInfoValue(elementId);
            const tagLabel = element.introText || element.intro_text || '';
            const tagConfig = element.config || {};
            
            // Check if this tag field should be hidden in reports
            if (tagConfig.visibleInReport === false) {
                return ''; // Don't render if explicitly set to false
            }
            
            if (!tagValue) return '';
            
            // tagValue can be a single tag ID or array of tag IDs (stored as strings)
            const tagIds = Array.isArray(tagValue) ? tagValue : [tagValue];
            
            // Get tag names from element config or reportData
            const tagData = reportData.tag_data || {};
            const tagNames = tagIds.map(tagId => {
                const tag = tagData[tagId] || { name: `Tag ${tagId}` };
                return escapeHtml(tag.name);
            }).join(', ');
            
            return `
                <div class="preview-element">
                    ${tagLabel ? `<div class="preview-input-label">${escapeHtml(tagLabel)}</div>` : ''}
                    <div class="preview-text-block">${tagNames}</div>
                </div>
            `;
            
        case 'creator-name':
            const creatorLabel = element.introText || element.intro_text || '';
            const creatorName = reportData.creator_name || 'Unknown';
            return `
                <div class="preview-element">
                    ${creatorLabel ? `<div class="preview-input-label">${escapeHtml(creatorLabel)}</div>` : ''}
                    <div class="preview-text-block">${escapeHtml(creatorName)}</div>
                </div>
            `;
            
        case 'location-contacts':
            const contactsLabel = element.introText || element.intro_text || '';
            // Get location contacts from reportData
            const contacts = reportData.location_contacts || [];
            let contactsHtml = '';
            if (contacts.length > 0) {
                contactsHtml = contacts.map(contact => {
                    const name = contact.full_name || contact.name || 'Unknown';
                    return `• ${escapeHtml(name)}`;
                }).join('<br>');
            } else {
                contactsHtml = '<em>No external users assigned</em>';
            }
            return `
                <div class="preview-element">
                    ${contactsLabel ? `<div style="font-size: 0.875rem; font-weight: 600; color: #374151; margin-bottom: 0.125rem;">${escapeHtml(contactsLabel)}</div>` : ''}
                    <div style="font-size: 0.875rem; line-height: 1.2;">${contactsHtml}</div>
                </div>
            `;
            
        case 'statistics-input':
            const statsLabel = element.introText || element.intro_text || element.config?.label || 'Statistics';
            const statisticsType = element.config?.statisticsType || 'average-current';
            const displayFormat = element.config?.displayFormat || 'number';
            const config = element.config || {};
            const valueLabels = config.valueLabels || {};
            const icons = config.icons || {};
            
            // Calculate statistics based on type
            let calculatedValue = null;
            let additionalInfo = '';
            let displayHtml = '';
            
            if (statisticsType === 'average-current') {
                // Calculate average from all evaluations in this report's documentation
                const documentation = reportData.documentation || [];
                const evaluations = documentation
                    .map(entry => entry.evaluation || entry.evaluation_score || entry.score)
                    .filter(score => score !== undefined && score !== null && score !== '' && score !== '-' && score !== 'N/A' && score !== 'Not Relevant')
                    .map(score => Number(score))
                    .filter(score => !isNaN(score));
                
                if (evaluations.length > 0) {
                    const sum = evaluations.reduce((acc, val) => acc + val, 0);
                    const average = sum / evaluations.length;
                    calculatedValue = Math.round(average); // Round to full number
                }
            } else if (statisticsType === 'average-previous') {
                // Calculate average from previous report (same location and template)
                const previousAverage = reportData.previous_report_average;
                const previousDate = reportData.previous_report_date;
                
                if (previousAverage !== undefined && previousAverage !== null) {
                    calculatedValue = Math.round(previousAverage);
                    if (previousDate) {
                        const date = new Date(previousDate);
                        const formattedDate = date.toLocaleDateString('da-DK', { month: 'long', year: 'numeric' });
                        additionalInfo = `<div style="font-size: 0.75rem; color: #9ca3af; margin-top: 0.25rem;">From: ${formattedDate}</div>`;
                    }
                } else {
                    additionalInfo = '<div style="font-size: 0.75rem; color: #ef4444; margin-top: 0.25rem;">No previous report available for this location</div>';
                }
            } else if (statisticsType === 'graph-yearly') {
                // Show graph of yearly averages
                const yearlyData = reportData.yearly_averages || [];
                
                if (yearlyData.length > 0) {
                    // Generate simple bar chart
                    const maxValue = 10; // Evaluations are 0-10
                    const barWidth = Math.min(60, 300 / yearlyData.length); // Responsive bar width
                    
                    const chartHtml = yearlyData.map(item => {
                        const height = (item.average / maxValue) * 100; // Percentage height
                        const date = new Date(item.date || item.period);
                        const label = date.toLocaleDateString('da-DK', { month: 'short', year: 'numeric' });
                        const roundedAvg = Math.round(item.average);
                        
                        return `
                            <div style="display: flex; flex-direction: column; align-items: center; gap: 0.25rem;">
                                <div style="font-size: 0.75rem; font-weight: 600; color: #374151;">${roundedAvg}</div>
                                <div style="width: ${barWidth}px; height: 120px; background: #f3f4f6; border-radius: 0.25rem; display: flex; flex-direction: column; justify-content: flex-end; overflow: hidden;">
                                    <div style="width: 100%; height: ${height}%; background: linear-gradient(to top, #3b82f6, #60a5fa); border-radius: 0.25rem 0.25rem 0 0;"></div>
                                </div>
                                <div style="font-size: 0.625rem; color: #6b7280; text-align: center; max-width: ${barWidth}px; word-wrap: break-word;">${label}</div>
                            </div>
                        `;
                    }).join('');
                    
                    // Override displayHtml for graph type
                    displayHtml = `
                        <div style="display: flex; gap: 0.75rem; align-items: flex-end; overflow-x: auto; padding: 0.5rem 0;">
                            ${chartHtml}
                        </div>
                    `;
                    calculatedValue = 'graph'; // Signal that we're showing a graph
                } else {
                    additionalInfo = '<div style="font-size: 0.75rem; color: #ef4444; margin-top: 0.25rem;">No historical data available</div>';
                }
            }
            
            // Generate display HTML (if not already set by graph logic)
            if (calculatedValue !== 'graph') {
                if (calculatedValue !== null) {
                    const valueLabel = valueLabels[calculatedValue] || '';
                    
                    if (displayFormat === 'icon' && icons[calculatedValue]) {
                        // Display as icon
                        displayHtml = `
                            <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 0.5rem;">
                                <img src="${icons[calculatedValue]}" alt="Score ${calculatedValue}" style="height: 3rem; width: 3rem; object-fit: contain;">
                                ${valueLabel ? `<span style="font-size: 0.875rem; color: #6b7280;">${escapeHtml(valueLabel)}</span>` : ''}
                            </div>
                        `;
                    } else {
                        // Display as number
                        displayHtml = `
                            <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 0.25rem;">
                                <span style="font-size: 2rem; font-weight: 700; color: #374151;">${calculatedValue}</span>
                                ${valueLabel ? `<span style="font-size: 0.875rem; color: #6b7280;">${escapeHtml(valueLabel)}</span>` : ''}
                            </div>
                        `;
                    }
                } else {
                    displayHtml = '<span style="font-size: 0.875rem; color: #9ca3af;">No data available</span>';
                }
            }
            
            // Layout: graph type spans full width, others use two-column layout
            const isGraph = statisticsType === 'graph-yearly';
            const containerStyle = isGraph 
                ? 'display: block;' 
                : 'display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; align-items: start;';
            
            return `
                <div class="preview-element">
                    ${statsLabel ? `<div class="preview-input-label">${escapeHtml(statsLabel)}</div>` : ''}
                    <div style="padding: 1rem; background: #f9fafb; border-radius: 0.5rem; margin-top: 0.5rem;">
                        <div style="${containerStyle}">
                            ${isGraph ? '' : '<div style="display: flex; align-items: center; min-height: 48px;"></div>'}
                            <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 0.5rem;">
                                ${displayHtml}
                            </div>
                        </div>
                        ${additionalInfo}
                    </div>
                </div>
            `;
            
        default:
            return '';
    }
}

/**
 * Close generated report preview modal
 */
function closeReportGeneratedPreview() {
    const modal = document.querySelector('.preview-modal');
    if (modal) {
        modal.remove();
    }
}

/**
 * Edit a draft report
 */
async function editReport(reportId) {
    try {
        const report = await apiCall(`/reports/${reportId}`, {
            headers: auth.getAuthHeaders()
        });
        
        if (report.status !== 'draft') {
            showError('Only draft reports can be edited');
            return;
        }
        
        // Load the template
        const template = report.template;
        
        // Set up report creation state
        reportCreationState.currentReport = {
            _id: report._id,
            template_id: report.template_id,
            template_name: report.template_name,
            template: template,
            title: report.title
        };
        reportCreationState.formData = report.form_data || { info: {}, documentation: [] };
        reportCreationState.currentTab = 'info';
        
        // Migrate documentation data if needed (for dynamic templates)
        if (template.documentation_layout === 'dynamic' && report.documentation) {
            console.log('DEBUG: Migrating documentation data on edit');
            console.log('DEBUG: Documentation array:', report.documentation);
            
            // Initialize dynamicDocumentation structure
            reportCreationState.formData.dynamicDocumentation = {};
            
            // Convert flat array with zone property back to zone-based structure
            report.documentation.forEach(entry => {
                if (entry.zone) {
                    const zoneName = entry.zone;
                    if (!reportCreationState.formData.dynamicDocumentation[zoneName]) {
                        reportCreationState.formData.dynamicDocumentation[zoneName] = [];
                    }
                    
                    // Remove the zone property from the entry before storing
                    const { zone, ...entryWithoutZone } = entry;
                    reportCreationState.formData.dynamicDocumentation[zoneName].push(entryWithoutZone);
                }
            });
            
            console.log('DEBUG: Migrated dynamicDocumentation:', reportCreationState.formData.dynamicDocumentation);
        }
        
        // Show report edit dialog
        showReportEditDialog();
    } catch (error) {
        console.error('Failed to load report:', error);
        showError('Failed to load report: ' + (error.message || 'Unknown error'));
    }
}

/**
 * Delete a draft report
 */
async function deleteReport(reportId) {
    try {
        const confirmed = await showConfirmDialog({
            title: 'Delete Report',
            message: 'Are you sure you want to delete this draft report? This action cannot be undone.',
            confirmText: 'Delete',
            cancelText: 'Cancel',
            confirmClass: 'bg-red-600 hover:bg-red-500',
            icon: 'warning'
        });
        
        if (!confirmed) return;
        
        await apiCall(`/reports/${reportId}`, {
            method: 'DELETE',
            headers: auth.getAuthHeaders()
        });
        
        showSuccess('Report deleted successfully');
        
        // Reload reports list
        await window.filterReports();
    } catch (error) {
        console.error('Failed to delete report:', error);
        showError('Failed to delete report: ' + (error.message || 'Unknown error'));
    }
}

/**
 * Clear all report filters
 */
window.clearReportFilters = function() {
    // Reset date filter to "all"
    const dateFilter = document.getElementById('report-date-filter');
    if (dateFilter) dateFilter.value = 'all';
    
    // Reset template filter to "all"
    const templateFilter = document.getElementById('report-template-filter');
    if (templateFilter) templateFilter.value = 'all';
    
    // Reset location filter to "all"
    const locationFilter = document.getElementById('report-location-filter');
    if (locationFilter) locationFilter.value = 'all';
    
    // Reset status checkboxes to draft and published
    const checkboxes = document.querySelectorAll('.status-checkbox');
    checkboxes.forEach(cb => {
        cb.checked = (cb.value === 'draft' || cb.value === 'published');
    });
    
    // Update status filter display
    window.updateStatusFilter();
};

/**
 * View full-size image in modal
 */
function viewFullImage(imageUrl) {
    const modal = document.createElement('div');
    modal.className = 'fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4';
    modal.onclick = () => modal.remove();
    
    modal.innerHTML = `
        <div class="relative max-w-7xl max-h-full">
            <button onclick="this.parentElement.parentElement.remove()" 
                    class="absolute -top-10 right-0 text-white hover:text-gray-300">
                <svg class="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
            <img src="${imageUrl}" class="max-w-full max-h-[90vh] object-contain" onclick="event.stopPropagation()">
        </div>
    `;
    
    document.body.appendChild(modal);
}

/**
 * Download report as PDF
 */
async function downloadReportPDF(reportId, reportTitle) {
    try {
        const container = document.getElementById('preview-pages-container');
        if (!container) {
            throw new Error('Preview container not found');
        }

        // Show loading indicator
        const button = event.target.closest('button');
        const originalText = button.innerHTML;
        button.disabled = true;
        button.innerHTML = `
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 inline" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Generating PDF...
        `;

        // Get all pages
        const pages = container.querySelectorAll('.preview-page');
        
        // A4 dimensions in mm
        const pdfWidth = 210;
        const pdfHeight = 297;
        
        // Create PDF using global jsPDF from CDN
        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });

        // Process each page
        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];
            
            // Capture page as canvas
            const canvas = await html2canvas(page, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff'
            });
            
            // Calculate dimensions to fit A4
            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;
            
            // Add page to PDF (first page already exists)
            if (i > 0) {
                pdf.addPage();
            }
            
            // Add image to PDF
            const imgData = canvas.toDataURL('image/jpeg', 0.95);
            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
        }

        // Generate filename
        const timestamp = new Date().toISOString().slice(0, 10);
        const filename = `${reportTitle.replace(/[^a-z0-9]/gi, '_')}_${timestamp}.pdf`;
        
        // Download PDF
        pdf.save(filename);

        // Restore button
        button.disabled = false;
        button.innerHTML = originalText;
        
    } catch (error) {
        console.error('Error generating PDF:', error);
        alert('Error generating PDF. Please try again.');
    }
}

// Export for window access
window.generateReport = generateReport;
window.viewReport = viewReport;
window.editReport = editReport;
window.deleteReport = deleteReport;
window.closeReportGeneratedPreview = closeReportGeneratedPreview;
window.downloadReportPDF = downloadReportPDF;
window.viewFullImage = viewFullImage;
// Note: window.filterReports is already assigned above in the filter logic section
// Note: window.clearReportFilters is already assigned above
window.showReportColumnMenu = showReportColumnMenu;
/**
 * Add new dynamic entry
 */
function addDynamicEntry(zoneName, elementId) {
    openDynamicEntryModal(zoneName, elementId, -1);
}

/**
 * Edit existing dynamic entry
 */
function editDynamicEntry(zoneName, entryIndex, elementId) {
    openDynamicEntryModal(zoneName, elementId, entryIndex);
}

/**
 * Delete dynamic entry
 */
async function deleteDynamicEntry(zoneName, entryIndex) {
    const confirmDelete = await showConfirmDialog({
        title: 'Delete Entry',
        message: 'Are you sure you want to delete this entry?',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        confirmClass: 'bg-red-600 hover:bg-red-700'
    });
    
    if (!confirmDelete) return;
    
    reportCreationState.formData.dynamicDocumentation[zoneName].splice(entryIndex, 1);
    
    // Re-render the documentation tab
    const container = document.getElementById('tab-content-area');
    if (container) {
        renderDocumentationTab(container);
    }
    
    showSuccess('Entry deleted');
}

/**
 * Open modal for adding/editing dynamic entry
 */
function openDynamicEntryModal(zoneName, elementId, entryIndex) {
    const template = reportCreationState.currentReport.template;
    const elements = template.elements || [];
    const docElement = elements.find(el => (el.id === elementId || el._id === elementId) && el.zone === zoneName);
    
    if (!docElement) {
        showError('Documentation element not found');
        return;
    }

    const isEvaluation = docElement.elementType === 'evaluation-input';
    const isNew = entryIndex === -1;
    const existingEntry = isNew ? null : reportCreationState.formData.dynamicDocumentation[zoneName][entryIndex];

    // Store context for save
    window._dynamicEntryContext = { zoneName, entryIndex };

    // Create modal
    const modal = document.createElement('div');
    modal.className = 'fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50';
    modal.id = 'documentation-modal';
    
    const evalConfig = docElement.config || {};
    const scaleMin = evalConfig.scaleMin || 0;
    const scaleMax = evalConfig.scaleMax || 10;
    const allowNotRelevant = evalConfig.allowNotRelevant || false;

    modal.innerHTML = `
        <div class="relative top-20 mx-auto p-5 border w-11/12 max-w-4xl shadow-lg rounded-md bg-white">
            <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-medium text-gray-900">
                    ${isNew ? 'Add' : 'Edit'} Entry
                </h3>
                <button onclick="window.closeDynamicEntryModal()" class="text-gray-400 hover:text-gray-500">
                    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <div class="space-y-4">
                ${isEvaluation ? `
                    <!-- Evaluation Score -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            ${docElement.introText || 'Evaluation Score'}
                        </label>
                        <div class="flex flex-wrap gap-2">
                            ${Array.from({length: scaleMax - scaleMin + 1}, (_, i) => {
                                const score = scaleMin + i;
                                const savedEval = existingEntry?.evaluation ? Number(existingEntry.evaluation) : null;
                                const isSelected = savedEval === score;
                                return `
                                    <button type="button" 
                                            id="score-${score}"
                                            onclick="window.selectEvaluationScore(${score})"
                                            class="px-4 py-2 border rounded-md hover:bg-gray-50 ${isSelected ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-700 border-gray-300'}">
                                        ${score}
                                    </button>
                                `;
                            }).join('')}
                            ${allowNotRelevant ? `
                                <button type="button" 
                                        id="score-na"
                                        onclick="window.selectEvaluationScore('N/A')"
                                        class="px-4 py-2 border rounded-md hover:bg-gray-50 ${existingEntry?.evaluation === 'N/A' ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-700 border-gray-300'}">
                                    Not Relevant
                                </button>
                            ` : ''}
                        </div>
                        <input type="hidden" id="selected-score" value="${existingEntry?.evaluation || ''}">
                    </div>
                ` : ''}

                <!-- Text Description -->
                <div>
                    <label for="doc-text" class="block text-sm font-medium text-gray-700 mb-2">
                        Description
                    </label>
                    <textarea id="doc-text" rows="4" 
                              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                              placeholder="Enter description...">${existingEntry?.text || ''}</textarea>
                </div>

                <!-- Images -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        Images (optional)
                    </label>
                    <div id="doc-images-container" class="grid grid-cols-4 gap-2">
                        ${existingEntry?.images ? existingEntry.images.map((img, imgIndex) => {
                            let displayUrl;
                            
                            // Handle different image formats
                            if (typeof img === 'string') {
                                // Could be data URL or server URL
                                displayUrl = img;
                            } else if (typeof img === 'object' && img !== null) {
                                // Object format - could have various properties
                                displayUrl = img.thumbnail || img.url || img.serverUrl;
                            }
                            
                            // Ensure full URL if it's a relative path
                            if (displayUrl && !displayUrl.startsWith('http') && !displayUrl.startsWith('data:')) {
                                displayUrl = window.location.origin + displayUrl;
                            }
                            
                            return `
                            <div class="relative group" data-image-index="${imgIndex}">
                                <img src="${displayUrl}" 
                                     onclick="window.viewFullImage('${displayUrl}')"
                                     class="h-24 w-24 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                                     alt="Documentation image ${imgIndex + 1}">
                                <button onclick="window.removeDocImage(${imgIndex})" 
                                        class="absolute top-1 right-1 bg-red-600 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        `}).join('') : ''}
                    </div>
                    <button onclick="window.addDocImage()" 
                            class="mt-2 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                        <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Add Image
                    </button>
                    <input type="file" id="doc-image-input" accept="image/*" class="hidden" onchange="window.handleDocImageUpload(event)">
                </div>
            </div>

            <!-- Actions -->
            <div class="mt-6 flex justify-end space-x-3">
                <button onclick="window.closeDynamicEntryModal()" 
                        class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                    Cancel
                </button>
                <button onclick="window.saveDynamicEntry()" 
                        class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700">
                    ${isNew ? 'Add Entry' : 'Save Changes'}
                </button>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
}

/**
 * Close dynamic entry modal
 */
function closeDynamicEntryModal() {
    const modal = document.getElementById('documentation-modal');
    if (modal) {
        modal.remove();
    }
    window._dynamicEntryContext = null;
}

/**
 * Save dynamic entry
 */
function saveDynamicEntry() {
    const context = window._dynamicEntryContext;
    if (!context) return;

    const { zoneName, entryIndex } = context;
    const isNew = entryIndex === -1;

    // Get form values
    const score = document.getElementById('selected-score')?.value;
    const text = document.getElementById('doc-text')?.value || '';

    // Get images from container
    const images = [];
    document.querySelectorAll('#doc-images-container [data-image-index]').forEach(imgEl => {
        const img = imgEl.querySelector('img');
        if (img) {
            const src = img.src;
            images.push(src);
        }
    });

    // Create entry object
    const entry = { text, images };
    if (score) {
        entry.evaluation = score === 'N/A' ? 'N/A' : parseInt(score);
    }

    // Save to state
    if (isNew) {
        reportCreationState.formData.dynamicDocumentation[zoneName].push(entry);
    } else {
        reportCreationState.formData.dynamicDocumentation[zoneName][entryIndex] = entry;
    }

    // Close modal and refresh
    closeDynamicEntryModal();
    
    // Re-render the documentation tab
    const container = document.getElementById('tab-content-area');
    if (container) {
        renderDocumentationTab(container);
    }

    showSuccess(isNew ? 'Entry added' : 'Entry updated');
}

window.toggleReportColumn = toggleReportColumn;
window.resetReportColumnsToDefault = resetReportColumnsToDefault;
window.selectTemplateForReport = selectTemplateForReport;
window.closeTemplateSelectionModal = closeTemplateSelectionModal;
window.closeReportEditDialog = closeReportEditDialog;
window.switchReportTab = switchReportTab;
window.updateReportTitle = updateReportTitle;
window.updateFormData = updateFormData;
window.updateLocationContacts = updateLocationContacts;
window.openDocumentationEntry = openDocumentationEntry;
window.editDocumentationEntry = editDocumentationEntry;
window.deleteDocumentationEntry = deleteDocumentationEntry;
window.closeDocumentationModal = closeDocumentationModal;
window.selectEvaluationScore = selectEvaluationScore;
window.addDocImage = addDocImage;
window.handleDocImageUpload = handleDocImageUpload;
window.removeDocImage = removeDocImage;
window.saveDocumentationEntry = saveDocumentationEntry;
window.saveReportDraft = saveReportDraft;
window.publishReport = publishReport;
window.addDynamicEntry = addDynamicEntry;
window.editDynamicEntry = editDynamicEntry;
window.deleteDynamicEntry = deleteDynamicEntry;
window.closeDynamicEntryModal = closeDynamicEntryModal;
window.saveDynamicEntry = saveDynamicEntry;

// Load column preferences on module initialization
loadReportsColumnPreferences();

export default {
    showReports,
    generateReport,
    filterReports,
    clearReportFilters
};
